import { useEffect, useMemo, useState } from "react";
import { useNotification } from "./NotifPopup";
import api from "../services/axiosInstance";
import { backendPort } from "../components/Fungsiku";
import { FormasiBan } from "./FormasiBan";
import { PageKonten9_Show } from "./Page9_Show";
import { PageKonten9_Pict } from "./Page9_Pict";
import { PageKonten15OdoTd } from "./Page25_UpdateData";
import { PageKonten32_Rotasi } from "./Page32_Rotasi";
import { ModalCariBan, ModalCariMT } from "./Page27_Cari";
import { useGlobalOpsi } from "../components/GlobalOpsi";

const IRREGULAR_ACTIONS = [
  {
    value: "storing",
    title: "STORING",
    description: "Catat aktivitas insidental ban di lapangan.",
    submitLabel: "Simpan STORING",
  },
  {
    value: "ganti_odo",
    title: "PENGGANTIAN ODO/REFRESH",
    description: "Maintence system terkait pergantian odo.",
    submitLabel: "Simpan",
  },
  {
    value: "ubah_seri",
    title: "PERUBAHAN ID UNIK",
    description: "Maintenance system terkait pergantian id.",
    submitLabel: "Simpan",
  }
];

const panelAccentClassByIrregularAction = (actionValue) => {
  const value = String(actionValue || "").trim();
  if (value === "storing") return "panel-accent-lav";
  if (value === "ganti_odo") return "panel-accent-sky";
  if (value === "ubah_seri") return "panel-accent-mint";
  return "panel-accent-default";
};

const STORING_TYPES = [
  { value: "", label: "-Pilih Jenis Storing-" },
  { value: "tambal_ban", label: "Tambal Ban" },
  { value: "rotasi", label: "Rotasi" },
];

const STORING_DISTANCE_OPTIONS = [
  { value: "", label: "-Input Perkiraan Jarak-" },
  { value: "0-10km", label: "0-10km" },
  { value: "10-20km", label: "10-20km" },
  { value: "20-30km", label: "20-30km" },
  { value: ">30km", label: ">30km" },
];

const REQ_GROUP_IRREGULAR_MT_DETAIL_LOAD = "irregular-mt-detail-load";
const REQ_GROUP_IRREGULAR_TAMBAL_OPSI_LOAD = "irregular-tambal-opsi-load";

const EMPTY_STORING_FORM = {
  jenis: "rotasi",
  lokasi: "",
  start: "",
  end: "",
  jarak: "",
  catatan_mt: "",
};

const EMPTY_UBAH_ID_FORM = {
  kodeCabang: "",
  noMemo: "-",
  tanggal: "",
  jenisId: "",
  alasan: "",
  selectedMt: null,
  nopolLama: "",
  nopolBaru: "",
  selectedBan: null,
  seriSementara: "",
  seriBaru: "",
  checkValidasi: false,
  namaUser: "",
};

const EMPTY_GANTI_ODO_FORM = {
  kodeCabang: "",
  noMemo: "-",
  tanggal: "",
  alasan: "",
  selectedMt: null,
  odoLastCheck: 0,
  odoLastCheckTgl: "",
  lastKmTempuh: 0,
  lastTdCheckTgl: "",
  lastTdCheckReady: false,
  tdTerpasangCount: 0,
  tdCadanganCount: 0,
  odoLepas: 0,
  odoLepasTgl: "",
  odoPasang: 0,
  odoPasangTgl: "",
  odoSaatIni: 0,
  odoSaatIniTgl: "",
  checkValidasi: false,
  namaUser: "",
  jenis_odo: "ganti_odo",
};
const NOMOR_PREVIEW_PLACEHOLDER = "-";
const buildNomorPreviewPlaceholder = ({ kodeCabang, prefix, tanggal }) => {
  const cabang = String(kodeCabang || "").trim().toUpperCase();
  const safePrefix = String(prefix || "WO").trim().toUpperCase() || "WO";
  const tgl = String(tanggal || "").trim();
  if (!cabang || !/^\d{4}-\d{2}-\d{2}$/.test(tgl)) return NOMOR_PREVIEW_PLACEHOLDER;
  const [year, month] = tgl.split("-");
  return `${cabang}/${safePrefix}/${month}/${year}/-`;
};

const parseDaftarBan = (raw) => {
  if (!raw) return {};
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      return typeof parsed === "object" && parsed ? parsed : {};
    } catch {
      return {};
    }
  }
  return typeof raw === "object" && raw ? raw : {};
};
const getTambalStatusOptions = (statusBeforeRaw) => {
  const statusBefore = String(statusBeforeRaw || "").trim().toUpperCase();
  if (statusBefore === "NT") return ["NT", "UT", "CASING"];
  if (statusBefore === "UT") return ["UT", "CASING"];
  const vt = statusBefore.match(/^VT-(\d+)$/);
  const uv = statusBefore.match(/^UV-(\d+)$/);
  const tier = vt?.[1] || uv?.[1] || "";
  if (vt?.[1]) return [`VT-${tier}`, `UV-${tier}`, "CASING"];
  if (uv?.[1]) return [`UV-${tier}`, "CASING"];
  return [statusBefore || "-"];
};
const sanitizeNopolInput = (value) => String(value || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
const isNopolValueValid = (value) => /^[A-Z0-9]+$/.test(String(value || "").trim());
const sanitizeSeriBanInput = (value) => String(value || "").toUpperCase().replace(/[^A-Z0-9-]/g, "");
const isSeriBanValueValid = (value) => /^[A-Z0-9-]+$/.test(String(value || "").trim());

function ModalTambalDetail({
  open,
  row,
  opsiJenisTambal = [],
  opsiBahanTambal = [],
  onClose,
  onSave,
}) {
  const [form, setForm] = useState({
    jenis_tambal: "",
    bahan_tambal: "",
    qty_tambal: 0,
    catatan: "",
  });

  useEffect(() => {
    if (!open) return;
    setForm({
      jenis_tambal: String(row?.jenis_tambal || "").trim(),
      bahan_tambal: String(row?.bahan_tambal || "").trim(),
      qty_tambal: Number(row?.qty_tambal || 0),
      catatan: String(row?.catatan || ""),
    });
  }, [open, row]);

  const qtyTambal = Number(form.qty_tambal);
  const invalidJenisTambal = !String(form.jenis_tambal || "").trim();
  const invalidQtyTambal = !Number.isFinite(qtyTambal) || qtyTambal < 0 || qtyTambal > 4;

  if (!open) return null;

  return (
    <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
      <div className="page16-modal-card" style={{ width: "min(720px, 94vw)" }}>
        <div className="d-flex justify-content-between align-items-start mb-3 pb-2 border-bottom">
          <div>
            <h5 className="mb-1">Keterangan Tambal Ban</h5>
            <small className="text-muted">{`${String(row?.seri_ban || "-")} | ${String(row?.posisi || "-")}`}</small>
          </div>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onClose}>
            Tutup
          </button>
        </div>

        <div className="row g-3">
          <div className="col-12 col-md-4">
            <label className="form-label">Jenis Tambal</label>
            <select
              className={`form-select ${invalidJenisTambal ? "field-required-invalid" : ""}`}
              value={form.jenis_tambal}
              onChange={(e) => setForm((prev) => ({ ...prev, jenis_tambal: e.target.value }))}
            >
              <option value="">Pilih Jenis Tambal</option>
              {(Array.isArray(opsiJenisTambal) ? opsiJenisTambal : []).map((item) => (
                <option key={`opsi-jenis-tambal-storing-${item}`} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">Bahan Tambal</label>
            <select
              className="form-select"
              value={form.bahan_tambal}
              onChange={(e) => setForm((prev) => ({ ...prev, bahan_tambal: e.target.value }))}
            >
              <option value="">Pilih Bahan Tambal</option>
              {(Array.isArray(opsiBahanTambal) ? opsiBahanTambal : []).map((item) => (
                <option key={`opsi-bahan-tambal-storing-${item}`} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">Quantity</label>
            <input
              type="number"
              min="0"
              max="4"
              step="1"
              className={`form-control ${invalidQtyTambal ? "field-required-invalid" : ""}`}
              value={Number(form.qty_tambal || 0)}
              onChange={(e) => setForm((prev) => ({ ...prev, qty_tambal: Number(e.target.value || 0) }))}
            />
          </div>
          <div className="col-12">
            <label className="form-label">Catatan</label>
            <textarea
              rows={2}
              className="form-control"
              placeholder="Masukkan catatan tambal ban..."
              value={form.catatan}
              onChange={(e) => setForm((prev) => ({ ...prev, catatan: e.target.value }))}
            />
          </div>
        </div>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
            Batal
          </button>
          <button
            type="button"
            className="btn btn-primary"
            disabled={invalidJenisTambal || invalidQtyTambal}
            onClick={() => onSave({
              jenis_tambal: String(form.jenis_tambal || "").trim(),
              bahan_tambal: String(form.bahan_tambal || "").trim(),
              qty_tambal: Number(form.qty_tambal || 0),
              catatan: String(form.catatan || ""),
            })}
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  );
}

export function PageKonten26Irregular({ authIdentity = {}, globalOpsi, resendToken = 0, actionScope = "all" }) {
  const { showNotif } = useNotification();
  const { manualResyncGlobalOpsi } = useGlobalOpsi();
  const actorKodeCabang = String(authIdentity?.kode_cabang || "").trim();
  const actorNama = String(authIdentity?.nama || "").trim();
  const initialUserCabang = actorKodeCabang;
  const initialIsPusat = initialUserCabang === "C-1";
  const initialDefaultCabang = initialIsPusat ? "" : initialUserCabang;
  const labelUpload = "Upload Dokumen Storing";
  const [activeAction, setActiveAction] = useState("");
  const [formTemplate, setFormTemplate] = useState({
    kodeCabang: initialDefaultCabang,
    nomor: NOMOR_PREVIEW_PLACEHOLDER,
    tanggal: "",
    mt: "",
    catatan: "",
  });
  const [storingForm, setStoringForm] = useState(EMPTY_STORING_FORM);
  const [mtProfilMap, setMtProfilMap] = useState({});
  const [mtDetailMap, setMtDetailMap] = useState({});
  const [storingBanData, setStoringBanData] = useState({
    loading: false,
    daftarKodeBan: {},
    banDetails: {},
    banEventMap: {},
  });
  const [showPickBanModal, setShowPickBanModal] = useState(false);
  const [showDetailMtPage, setShowDetailMtPage] = useState(false);
  const [selectedMtDetail, setSelectedMtDetail] = useState(null);
  const [selectedPosisi, setSelectedPosisi] = useState([]);
  const [activeModalPosisi, setActiveModalPosisi] = useState("");
  const [activeCardPosisi, setActiveCardPosisi] = useState("");
  const [banActionMap, setBanActionMap] = useState({});
  const [namaPemeriksaStoring, setNamaPemeriksaStoring] = useState(actorNama || "");
  const [attachments, setAttachments] = useState([]);
  const [attachmentsUbahId, setAttachmentsUbahId] = useState([]);
  const [invalidCaptionIndexesStoring, setInvalidCaptionIndexesStoring] = useState([]);
  const [invalidCaptionIndexesUbahId, setInvalidCaptionIndexesUbahId] = useState([]);
  const [isSubmittingStoring, setIsSubmittingStoring] = useState(false);
  const [isSubmittingUbahId, setIsSubmittingUbahId] = useState(false);
  const [ubahIdForm, setUbahIdForm] = useState({
    ...EMPTY_UBAH_ID_FORM,
    kodeCabang: initialDefaultCabang,
    tanggal: "",
    namaUser: actorNama || "",
  });
  const [gantiOdoForm, setGantiOdoForm] = useState({
    ...EMPTY_GANTI_ODO_FORM,
    kodeCabang: initialDefaultCabang,
    tanggal: "",
    namaUser: actorNama || "",
  });
  const [attachmentsGantiOdo, setAttachmentsGantiOdo] = useState([]);
  const [invalidCaptionIndexesGantiOdo, setInvalidCaptionIndexesGantiOdo] = useState([]);
  const [isSubmittingGantiOdo, setIsSubmittingGantiOdo] = useState(false);
  const [submitAttemptedGantiOdo, setSubmitAttemptedGantiOdo] = useState(false);
  const [showGantiOdoZeroConfirmModal, setShowGantiOdoZeroConfirmModal] = useState(false);
  const [showRefreshOdoZeroConfirmModal, setShowRefreshOdoZeroConfirmModal] = useState(false);
  const [showCariBanIdUnikModal, setShowCariBanIdUnikModal] = useState(false);
  const [showCariMtIdUnikModal, setShowCariMtIdUnikModal] = useState(false);
  const [showCariMtGantiOdoModal, setShowCariMtGantiOdoModal] = useState(false);
  const [showCariMtStoringModal, setShowCariMtStoringModal] = useState(false);
  const [showTdUpdateModalGantiOdo, setShowTdUpdateModalGantiOdo] = useState(false);
  const [showOdoUpdateModalStoring, setShowOdoUpdateModalStoring] = useState(false);
  const [showTdUpdateModalStoring, setShowTdUpdateModalStoring] = useState(false);
  const [showRotasiBanModal, setShowRotasiBanModal] = useState(false);
  const [showTambalDetailModal, setShowTambalDetailModal] = useState(false);
  const [activeTambalDetailPosisi, setActiveTambalDetailPosisi] = useState("");
  const [opsiJenisTambal, setOpsiJenisTambal] = useState([]);
  const [opsiBahanTambal, setOpsiBahanTambal] = useState([]);
  const [rotasiModalData, setRotasiModalData] = useState({});
  const [storingCheckRefreshTick, setStoringCheckRefreshTick] = useState(0);
  const [storingLastCheck, setStoringLastCheck] = useState({
    loading: false,
    odo: { value: 0, date: "" },
    td: { terpasang: 0, cadangan: 0, total: 0, oldestDate: "" },
    today: { odo: false, td: false },
  });

  const todayText = useMemo(
    () =>
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "2-digit",
        month: "long",
        year: "numeric",
      }),
    []
  );
  const todayKey = useMemo(() => {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, "0");
    const d = String(now.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }, []);
  const formatDate = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "-";
    return d.toLocaleDateString("id-ID");
  };
  const formatDateKey = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };
  const dayDiffLabel = (value) => {
    const key = formatDateKey(value);
    if (!key) return "-";
    const [y, m, d] = key.split("-").map((x) => Number(x));
    const target = new Date(y, (m || 1) - 1, d || 1);
    const [ty, tm, td] = todayKey.split("-").map((x) => Number(x));
    const today = new Date(ty, (tm || 1) - 1, td || 1);
    const diff = Math.max(0, Math.floor((today.getTime() - target.getTime()) / 86400000));
    return `${diff} hari lalu`;
  };
  const formatRibuanInput = (value) => Number(value || 0).toLocaleString("id-ID");
  const parseRibuanInput = (value) => {
    const digits = String(value || "").replace(/\D/g, "");
    return Number(digits || 0);
  };

  const irregularActions = useMemo(() => {
    const scope = String(actionScope || "all").trim().toLowerCase();
    if (scope === "storing_only") return IRREGULAR_ACTIONS.filter((x) => x.value === "storing");
    if (scope === "without_storing") return IRREGULAR_ACTIONS.filter((x) => x.value !== "storing");
    return IRREGULAR_ACTIONS;
  }, [actionScope]);
  const selectedAction = irregularActions.find((x) => x.value === activeAction) || null;
  const normalizedScope = String(actionScope || "all").trim().toLowerCase();
  const isStoringOnlyScope = normalizedScope === "storing_only";
  const opsiCabang = globalOpsi?.opsiCabang || [];
  const opsiMtSemua = globalOpsi?.opsiMT || [];
  const isPusat = actorKodeCabang === "C-1";
  const defaultKodeCabang = isPusat ? "" : actorKodeCabang;
  const namaCabangUser = useMemo(() => {
    if (isPusat) return "Pusat";
    return (
      (Array.isArray(opsiCabang) ? opsiCabang : []).find(
        (x) => String(x?.kode_cabang || "").trim() === actorKodeCabang
      )?.nama_cabang || actorKodeCabang || "-"
    );
  }, [actorKodeCabang, isPusat, opsiCabang]);

  const opsiMtByCabang = useMemo(() => {
    const kodeCabang = String(formTemplate.kodeCabang || "").trim();
    if (!kodeCabang) return [];
    return opsiMtSemua.filter((x) => x.kode_cabang === kodeCabang);
  }, [formTemplate.kodeCabang, opsiMtSemua]);

  const selectedMt = useMemo(
    () => opsiMtSemua.find((x) => x.id_mt === formTemplate.mt) || null,
    [opsiMtSemua, formTemplate.mt]
  );
  const selectedMtProfil = mtProfilMap?.[String(formTemplate.mt || "").trim()] || null;
  const activeModalBan = storingBanData.banDetails?.[activeModalPosisi] || null;
  const activeCardBan = storingBanData.banDetails?.[activeCardPosisi] || null;

  useEffect(() => {
    const scope = String(actionScope || "all").trim().toLowerCase();
    if (scope !== "storing_only") return;
    if (activeAction === "storing") return;
    handlePilihAction("storing");
  }, [actionScope, activeAction]);

  useEffect(() => {
    if (!activeAction) return;
    if (irregularActions.some((x) => x.value === activeAction)) return;
    setActiveAction("");
  }, [activeAction, irregularActions]);
  useEffect(() => {
    if (activeAction !== "storing") return;
    const loadTambalOpsiTambahan = async () => {
      try {
        api.cancelPendingRequests({
          group: REQ_GROUP_IRREGULAR_TAMBAL_OPSI_LOAD,
          reason: "refresh opsi tambahan tambal storing",
        });
        const { data } = await api.get(`${backendPort}/api/main/load_opsi_tambahan_tambal`, {
          requestGroup: REQ_GROUP_IRREGULAR_TAMBAL_OPSI_LOAD,
          timeout: 30000,
        });
        setOpsiJenisTambal(Array.isArray(data?.opsiJenisTambal) ? data.opsiJenisTambal : []);
        setOpsiBahanTambal(Array.isArray(data?.opsiBahanTambal) ? data.opsiBahanTambal : []);
      } catch (err) {
        if (api.isCanceledError(err)) return;
        console.error("Gagal memuat opsi tambahan tambal storing:", err);
        setOpsiJenisTambal([]);
        setOpsiBahanTambal([]);
      }
    };
    loadTambalOpsiTambahan();
  }, [activeAction]);
  const isBanActionComplete = (action) => {
    const qtyTambal = Number(action?.qty_tambal ?? action?.patch_kebutuhan ?? action?.patch ?? 0);
    const statusAfter = String(action?.status_after || "").trim();
    const jenisTambal = String(action?.jenis_tambal || "").trim();
    return Number.isFinite(qtyTambal) && qtyTambal >= 0 && qtyTambal <= 4 && Boolean(statusAfter) && Boolean(jenisTambal);
  };
  const isBanActionDetailInvalid = (action) => {
    const qtyTambal = Number(action?.qty_tambal ?? action?.patch_kebutuhan ?? action?.patch ?? 0);
    return !String(action?.jenis_tambal || "").trim()
      || !Number.isFinite(qtyTambal)
      || qtyTambal < 0
      || qtyTambal > 4;
  };
  const cabangLabelUbahId = useMemo(() => {
    if (!isPusat) return namaCabangUser || "-";
    const kode = String(ubahIdForm.kodeCabang || "").trim();
    if (!kode) return "-";
    const found = opsiCabang.find((x) => x.kode_cabang === kode);
    return found?.nama_cabang || kode;
  }, [isPusat, namaCabangUser, ubahIdForm.kodeCabang, opsiCabang]);
  const cabangLabelGantiOdo = useMemo(() => {
    if (!isPusat) return namaCabangUser || "-";
    const kode = String(gantiOdoForm.kodeCabang || "").trim();
    if (!kode) return "-";
    const found = opsiCabang.find((x) => x.kode_cabang === kode);
    return found?.nama_cabang || kode;
  }, [isPusat, namaCabangUser, gantiOdoForm.kodeCabang, opsiCabang]);
  const gantiOdoAdjustment = useMemo(() => {
    const removed = Number(gantiOdoForm.odoLepas || 0);
    const install = Number(gantiOdoForm.odoPasang || 0);
    const diff = removed - install;
    return Number.isFinite(diff) ? diff : 0;
  }, [gantiOdoForm.odoLepas, gantiOdoForm.odoPasang]);
  const gantiOdoEquivalentCurrent = useMemo(() => {
    const current = Number(gantiOdoForm.odoSaatIni || 0);
    const adjustment = Number(gantiOdoAdjustment || 0);
    const value = current + adjustment;
    return Number.isFinite(value) ? value : 0;
  }, [gantiOdoForm.odoSaatIni, gantiOdoAdjustment]);
  const gantiOdoKmDelta = useMemo(() => {
    const equivalentCurrent = Number(gantiOdoEquivalentCurrent || 0);
    const lastCheck = Number(gantiOdoForm.odoLastCheck || 0);
    const value = equivalentCurrent - lastCheck;
    return Number.isFinite(value) ? value : 0;
  }, [gantiOdoEquivalentCurrent, gantiOdoForm.odoLastCheck]);
  const gantiOdoKmTempuh = useMemo(() => {
    const base = Number(gantiOdoForm.lastKmTempuh || 0);
    const delta = Number(gantiOdoKmDelta || 0);
    return base + delta;
  }, [gantiOdoForm.lastKmTempuh, gantiOdoKmDelta]);
  const gantiOdoSelisihKm = useMemo(() => Number(gantiOdoKmDelta || 0), [gantiOdoKmDelta]);
  const gantiOdoSelisihHari = useMemo(() => {
    const startKey = formatDateKey(gantiOdoForm.odoLastCheckTgl || "");
    const endKey = formatDateKey(gantiOdoForm.odoSaatIniTgl || gantiOdoForm.tanggal || todayKey);
    if (!startKey || !endKey) return 1;
    const [sy, sm, sd] = startKey.split("-").map((n) => Number(n || 0));
    const [ey, em, ed] = endKey.split("-").map((n) => Number(n || 0));
    const start = new Date(sy, (sm || 1) - 1, sd || 1);
    const end = new Date(ey, (em || 1) - 1, ed || 1);
    const diff = Math.floor((end.getTime() - start.getTime()) / 86400000);
    return Math.max(1, diff);
  }, [gantiOdoForm.odoLastCheckTgl, gantiOdoForm.odoSaatIniTgl, gantiOdoForm.tanggal, todayKey]);
  const gantiOdoMaxSelisihKm = useMemo(
    () => Math.max(1, Number(gantiOdoSelisihHari || 1)) * 2000,
    [gantiOdoSelisihHari]
  );
  const isGantiOdoSelisihLimitValid = useMemo(
    () => Math.abs(Number(gantiOdoSelisihKm || 0)) <= Number(gantiOdoMaxSelisihKm || 0),
    [gantiOdoSelisihKm, gantiOdoMaxSelisihKm]
  );
  const gantiOdoMode = String(gantiOdoForm.jenis_odo || "ganti_odo").trim().toLowerCase();
  const isGantiOdoLepasPasangDateEditable = gantiOdoMode === "ganti_odo" || gantiOdoMode === "refresh_odo";
  const gantiOdoLepasPasangMinDate = formatDateKey(gantiOdoForm.odoLastCheckTgl || "");
  const gantiOdoLepasPasangMaxDate = formatDateKey(
    gantiOdoForm.odoSaatIniTgl || gantiOdoForm.tanggal || todayKey
  );
  const isGantiOdoLepasPasangDateValid = useMemo(() => {
    if (!isGantiOdoLepasPasangDateEditable) return true;
    const lepasDate = formatDateKey(gantiOdoForm.odoLepasTgl || "");
    const pasangDate = formatDateKey(gantiOdoForm.odoPasangTgl || "");
    if (!lepasDate || !pasangDate || lepasDate !== pasangDate) return false;
    if (gantiOdoLepasPasangMinDate && lepasDate < gantiOdoLepasPasangMinDate) return false;
    if (gantiOdoLepasPasangMaxDate && lepasDate > gantiOdoLepasPasangMaxDate) return false;
    return true;
  }, [
    gantiOdoForm.odoLepasTgl,
    gantiOdoForm.odoPasangTgl,
    gantiOdoLepasPasangMinDate,
    gantiOdoLepasPasangMaxDate,
    isGantiOdoLepasPasangDateEditable,
  ]);
  const gantiOdoMaxByLastCheck = useMemo(() => {
    const raw = Math.max(0, Math.trunc(Number(gantiOdoForm.odoLastCheck || 0)));
    const digitLen = Math.max(1, String(raw).length);
    return Number("9".repeat(digitLen));
  }, [gantiOdoForm.odoLastCheck]);
  const isGantiOdoReadyForVerify = useMemo(() => (
    !!String(gantiOdoForm.kodeCabang || "").trim()
      && !!String(gantiOdoForm.noMemo || "").trim()
      && !!String(gantiOdoForm.tanggal || "").trim()
      && !!gantiOdoForm.selectedMt
      && !!String(gantiOdoForm.alasan || "").trim()
      && Boolean(gantiOdoForm.lastTdCheckReady)
      && Number(gantiOdoForm.odoLepas) >= 0
      && Number(gantiOdoForm.odoPasang) >= 0
      && Number(gantiOdoForm.odoSaatIni) >= 0
      && !!String(gantiOdoForm.odoLepasTgl || "").trim()
      && !!String(gantiOdoForm.odoPasangTgl || "").trim()
      && !!String(gantiOdoForm.odoSaatIniTgl || "").trim()
  ), [gantiOdoForm]);
  const isGantiOdoValid = useMemo(() => {
    if (!isGantiOdoReadyForVerify) return false;
    if (!String(gantiOdoForm.namaUser || "").trim()) return false;
    if (!isGantiOdoLepasPasangDateValid) return false;
    if (gantiOdoMode === "refresh_odo") {
      return Number(gantiOdoForm.odoSaatIni || 0) >= 0 && gantiOdoSelisihKm >= 0 && isGantiOdoSelisihLimitValid;
    }
    if (gantiOdoMode === "koreksi_odo") {
      return Number(gantiOdoForm.odoSaatIni || 0) >= Number(gantiOdoForm.odoPasang || 0) && gantiOdoSelisihKm >= 0 && isGantiOdoSelisihLimitValid;
    }
    return (
      Number(gantiOdoForm.odoLepas || 0) >= Number(gantiOdoForm.odoLastCheck || 0)
      && gantiOdoSelisihKm >= 0
      && isGantiOdoSelisihLimitValid
    );
  }, [isGantiOdoReadyForVerify, isGantiOdoLepasPasangDateValid, gantiOdoForm, gantiOdoMode, gantiOdoSelisihKm, isGantiOdoSelisihLimitValid]);
  const gantiOdoAttachmentCount = useMemo(
    () => (Array.isArray(attachmentsGantiOdo) ? attachmentsGantiOdo.length : 0),
    [attachmentsGantiOdo]
  );
  const autoInvalidCaptionIndexesGantiOdo = useMemo(() => {
    if (!isGantiOdoReadyForVerify) return [];
    if (!Array.isArray(attachmentsGantiOdo) || attachmentsGantiOdo.length === 0) return [];
    return attachmentsGantiOdo
      .map((att, idx) => (String(att?.caption || "").trim() ? -1 : idx))
      .filter((idx) => idx >= 0);
  }, [attachmentsGantiOdo, isGantiOdoReadyForVerify]);
  const mergedInvalidCaptionIndexesGantiOdo = useMemo(
    () => [...new Set([...(invalidCaptionIndexesGantiOdo || []), ...autoInvalidCaptionIndexesGantiOdo])],
    [invalidCaptionIndexesGantiOdo, autoInvalidCaptionIndexesGantiOdo]
  );
  const invalidGantiOdoLampiran = activeAction === "ganti_odo"
    && isGantiOdoReadyForVerify
    && gantiOdoAttachmentCount === 0;
  const isGantiOdoAttachmentValid = !isGantiOdoReadyForVerify
    || (gantiOdoAttachmentCount > 0 && mergedInvalidCaptionIndexesGantiOdo.length === 0);
  const isUbahIdValid = useMemo(() => {
    const commonReady = !!String(ubahIdForm.kodeCabang || "").trim()
      && !!String(ubahIdForm.noMemo || "").trim()
      && !!String(ubahIdForm.tanggal || "").trim()
      && !!String(ubahIdForm.jenisId || "").trim()
      && !!String(ubahIdForm.alasan || "").trim()
      && !!String(ubahIdForm.namaUser || "").trim();
    if (!commonReady) return false;
    if (ubahIdForm.jenisId === "nopol") {
      const nopolBaru = String(ubahIdForm.nopolBaru || "").trim();
      return !!ubahIdForm.selectedMt
        && !!String(ubahIdForm.nopolLama || "").trim()
        && !!nopolBaru
        && isNopolValueValid(nopolBaru);
    }
    const seriBaru = String(ubahIdForm.seriBaru || "").trim();
    return !!ubahIdForm.selectedBan
      && !!String(ubahIdForm.seriSementara || "").trim()
      && !!seriBaru
      && isSeriBanValueValid(seriBaru);
  }, [ubahIdForm]);
  const isUbahIdReadyForVerify = useMemo(() => {
    const commonReady = !!String(ubahIdForm.kodeCabang || "").trim()
      && !!String(ubahIdForm.noMemo || "").trim()
      && !!String(ubahIdForm.tanggal || "").trim()
      && !!String(ubahIdForm.jenisId || "").trim()
      && !!String(ubahIdForm.alasan || "").trim();
    if (!commonReady) return false;
    if (ubahIdForm.jenisId === "nopol") {
      const nopolBaru = String(ubahIdForm.nopolBaru || "").trim();
      return !!ubahIdForm.selectedMt
        && !!String(ubahIdForm.nopolLama || "").trim()
        && !!nopolBaru
        && isNopolValueValid(nopolBaru);
    }
    if (ubahIdForm.jenisId === "seri_ban") {
      const seriBaru = String(ubahIdForm.seriBaru || "").trim();
      return !!ubahIdForm.selectedBan
        && !!String(ubahIdForm.seriSementara || "").trim()
        && !!seriBaru
        && isSeriBanValueValid(seriBaru);
    }
    return false;
  }, [ubahIdForm]);
  const ubahIdAttachmentCount = useMemo(
    () => (Array.isArray(attachmentsUbahId) ? attachmentsUbahId.length : 0),
    [attachmentsUbahId]
  );
  const autoInvalidCaptionIndexesUbahId = useMemo(() => {
    if (!isUbahIdReadyForVerify) return [];
    if (!Array.isArray(attachmentsUbahId) || attachmentsUbahId.length === 0) return [];
    return attachmentsUbahId
      .map((att, idx) => (String(att?.caption || "").trim() ? -1 : idx))
      .filter((idx) => idx >= 0);
  }, [attachmentsUbahId, isUbahIdReadyForVerify]);
  const mergedInvalidCaptionIndexesUbahId = useMemo(
    () => [...new Set([...(invalidCaptionIndexesUbahId || []), ...autoInvalidCaptionIndexesUbahId])],
    [invalidCaptionIndexesUbahId, autoInvalidCaptionIndexesUbahId]
  );
  const invalidUbahIdLampiran = activeAction === "ubah_seri"
    && ubahIdAttachmentCount === 0;
  const isUbahIdAttachmentValid = !isUbahIdReadyForVerify
    || (ubahIdAttachmentCount > 0 && mergedInvalidCaptionIndexesUbahId.length === 0);
  const selectedTambalBanRows = useMemo(() => (
    (Array.isArray(selectedPosisi) ? selectedPosisi : []).map((pos) => {
      const detail = storingBanData.banDetails?.[pos] || {};
      const action = banActionMap?.[pos] || {};
      const statusBefore = String(action?.status_before || detail?.status || "").trim();
      const defaultStatus = String(getTambalStatusOptions(statusBefore)?.[0] || statusBefore || "").trim();
      return {
        posisi: String(pos || "").trim(),
        id_ban: Number(detail?.idBan || storingBanData?.daftarKodeBan?.[pos] || 0),
        seri_ban: String(detail?.seri || "-"),
        status_before: statusBefore,
        status_after: String(action?.status_after || defaultStatus).trim(),
        qty_tambal: Number(action?.qty_tambal ?? action?.patch_kebutuhan ?? 0),
        jenis_tambal: String(action?.jenis_tambal || "").trim(),
        bahan_tambal: String(action?.bahan_tambal || "").trim(),
        catatan: String(action?.catatan || "").trim(),
      };
    }).filter((row) => row.posisi && row.id_ban > 0)
  ), [selectedPosisi, storingBanData, banActionMap]);
  const activeTambalDetailRow = useMemo(
    () => (Array.isArray(selectedTambalBanRows) ? selectedTambalBanRows : [])
      .find((row) => String(row?.posisi || "").trim() === String(activeTambalDetailPosisi || "").trim()) || null,
    [selectedTambalBanRows, activeTambalDetailPosisi]
  );
  const invalidStoringCabang = activeAction === "storing" && !String(formTemplate.kodeCabang || "").trim();
  const invalidStoringMt = activeAction === "storing" && !String(formTemplate.mt || "").trim();
  const invalidStoringJenis = false;
  const invalidStoringJarak = activeAction === "storing" && !String(storingForm.jarak || "").trim();
  const invalidStoringLokasi = activeAction === "storing" && !String(storingForm.lokasi || "").trim();
  const invalidStoringStart = activeAction === "storing" && !String(storingForm.start || "").trim();
  const invalidStoringEnd = activeAction === "storing" && !String(storingForm.end || "").trim();
  const invalidStoringTimeRange = activeAction === "storing"
    && Boolean(storingForm.start && storingForm.end)
    && String(storingForm.start) >= String(storingForm.end);
  const isJenisStoringTambal = activeAction === "storing" && String(storingForm.jenis || "").trim() === "tambal_ban";
  const isStoringHeaderReady = activeAction === "storing"
    && !invalidStoringCabang
    && !invalidStoringMt
    && !invalidStoringJenis
    && !invalidStoringJarak;
  const isStoringBaseReady = isStoringHeaderReady
    && !invalidStoringLokasi
    && !invalidStoringStart
    && !invalidStoringEnd
    && !invalidStoringTimeRange;
  const canShowStoringTambalFields = isStoringBaseReady && isJenisStoringTambal;
  const invalidUbahIdCabang = activeAction === "ubah_seri" && !String(ubahIdForm.kodeCabang || "").trim();
  const invalidUbahIdJenis = activeAction === "ubah_seri" && !String(ubahIdForm.jenisId || "").trim();
  const invalidUbahIdAlasan = activeAction === "ubah_seri" && !String(ubahIdForm.alasan || "").trim();
  const invalidUbahIdUser = activeAction === "ubah_seri" && isUbahIdReadyForVerify && !String(ubahIdForm.namaUser || "").trim();
  const invalidUbahIdNopolBaru = activeAction === "ubah_seri"
    && ubahIdForm.jenisId === "nopol"
    && !!ubahIdForm.selectedMt
    && !isNopolValueValid(ubahIdForm.nopolBaru);
  const invalidUbahIdSeriBaru = activeAction === "ubah_seri"
    && ubahIdForm.jenisId === "seri_ban"
    && !!ubahIdForm.selectedBan
    && !isSeriBanValueValid(ubahIdForm.seriBaru);
  const invalidGantiOdoCabang = activeAction === "ganti_odo" && !String(gantiOdoForm.kodeCabang || "").trim();
  const invalidGantiOdoMt = activeAction === "ganti_odo" && !gantiOdoForm.selectedMt;
  const invalidGantiOdoAlasan = activeAction === "ganti_odo" && !String(gantiOdoForm.alasan || "").trim();
  const invalidGantiOdoUser = activeAction === "ganti_odo" && isGantiOdoReadyForVerify && !String(gantiOdoForm.namaUser || "").trim();
  const invalidGantiOdoOdoLepas = submitAttemptedGantiOdo
    && gantiOdoMode !== "refresh_odo"
    && Number(gantiOdoForm.odoLepas || 0) < Number(gantiOdoForm.odoLastCheck || 0);
  const invalidGantiOdoOdoPasang = submitAttemptedGantiOdo
    && gantiOdoMode !== "refresh_odo"
    && (
      (gantiOdoMode === "ganti_odo" && Number(gantiOdoForm.odoPasang || 0) < Number(gantiOdoForm.odoLepas || 0))
      || (gantiOdoMode === "koreksi_odo" && Number(gantiOdoForm.odoSaatIni || 0) < Number(gantiOdoForm.odoPasang || 0))
    );
  const invalidGantiOdoOdoSaatIni = submitAttemptedGantiOdo
    && (
      (gantiOdoMode === "refresh_odo" && Number(gantiOdoForm.odoSaatIni || 0) <= 0)
      || (gantiOdoMode === "koreksi_odo" && Number(gantiOdoForm.odoSaatIni || 0) < Number(gantiOdoForm.odoPasang || 0))
    );
  const invalidGantiOdoSelisihKm = submitAttemptedGantiOdo && !isGantiOdoSelisihLimitValid;

  const handlePilihAction = (actionKey) => {
    setActiveAction(actionKey);
    setFormTemplate((prev) => ({
      ...prev,
      kodeCabang: defaultKodeCabang || prev.kodeCabang || "",
      nomor: NOMOR_PREVIEW_PLACEHOLDER,
      mt: "",
      tanggal: prev.tanggal || todayKey,
      catatan: "",
    }));
    setStoringForm(EMPTY_STORING_FORM);
    setStoringBanData({ loading: false, daftarKodeBan: {}, banDetails: {}, banEventMap: {} });
    setShowPickBanModal(false);
    setShowDetailMtPage(false);
    setSelectedMtDetail(null);
    setSelectedPosisi([]);
    setActiveModalPosisi("");
    setActiveCardPosisi("");
    setBanActionMap({});
    setNamaPemeriksaStoring(actorNama || "");
    setAttachments([]);
    setAttachmentsUbahId([]);
    setInvalidCaptionIndexesStoring([]);
    setInvalidCaptionIndexesUbahId([]);
    setUbahIdForm({
      ...EMPTY_UBAH_ID_FORM,
      kodeCabang: defaultKodeCabang,
      tanggal: todayKey,
      namaUser: actorNama || "",
    });
    setAttachmentsGantiOdo([]);
    setInvalidCaptionIndexesGantiOdo([]);
    setSubmitAttemptedGantiOdo(false);
    setShowGantiOdoZeroConfirmModal(false);
    setShowRefreshOdoZeroConfirmModal(false);
    setGantiOdoForm({
      ...EMPTY_GANTI_ODO_FORM,
      kodeCabang: defaultKodeCabang,
      tanggal: todayKey,
      odoLepasTgl: todayKey,
      odoPasangTgl: todayKey,
      odoSaatIniTgl: todayKey,
      namaUser: actorNama || "",
    });
    setShowCariBanIdUnikModal(false);
    setShowCariMtIdUnikModal(false);
    setShowCariMtGantiOdoModal(false);
    setShowCariMtStoringModal(false);
    setShowTdUpdateModalGantiOdo(false);
    setShowOdoUpdateModalStoring(false);
    setShowTdUpdateModalStoring(false);
    setShowTambalDetailModal(false);
    setActiveTambalDetailPosisi("");
    setShowRotasiBanModal(false);
    setRotasiModalData({});
    setStoringCheckRefreshTick(0);
    setStoringLastCheck({
      loading: false,
      odo: { value: 0, date: "" },
      td: { terpasang: 0, cadangan: 0, total: 0, oldestDate: "" },
      today: { odo: false, td: false },
    });
  };

  const handleGantiOdoTdSaved = () => {
    setGantiOdoForm((prev) => ({
      ...prev,
      selectedMt: prev.selectedMt ? { ...prev.selectedMt } : null,
    }));
  };
  const handleStoringLastCheckSaved = () => {
    setStoringCheckRefreshTick((prev) => prev + 1);
  };
  const handleOpenStoringRotasiModal = () => {
    const idMt = String(formTemplate.mt || "").trim();
    if (!idMt) {
      showNotif("error", "No. Pol belum dipilih.");
      return;
    }
    const mtDetail = mtDetailMap?.[idMt]
      || (Array.isArray(opsiMtSemua) ? opsiMtSemua.find((x) => String(x?.id_mt || "").trim() === idMt) : null)
      || selectedMt
      || {};
    const nopol = String(selectedMt?.nopol || mtDetail?.nopol || "").trim();
    if (!nopol) {
      showNotif("error", "Data No. Pol MT tidak ditemukan.");
      return;
    }
    setRotasiModalData({
      ...(mtDetail || {}),
      lampiran: [],
      lampiran_mt_event: "",
      context_mode: "storing_rotasi",
      id_mt: idMt,
      nopol,
      kode_cabang: String(formTemplate.kodeCabang || (!isPusat ? actorKodeCabang : "")).trim(),
      nomor_wo: String(formTemplate.nomor || "").trim(),
      tanggal_input: String(formTemplate.tanggal || todayKey).trim(),
      start: String(storingForm.start || "").trim(),
      end: String(storingForm.end || "").trim(),
      lokasi: String(storingForm.lokasi || "").trim(),
      jarak: String(storingForm.jarak || "").trim(),
      jumlah_mt: 1,
      id_mt_1: idMt,
      nopol_1: nopol,
      roda_1: Number(selectedMtProfil?.roda || mtDetail?.roda || selectedMt?.roda || 0),
      cadangan_1: Number(selectedMtProfil?.cadangan || mtDetail?.cadangan || selectedMt?.cadangan || 0),
      id_mt_2: "",
      nopol_2: "",
      roda_2: 0,
      cadangan_2: 0,
    });
    setShowRotasiBanModal(true);
  };

  useEffect(() => {
    const loadMtProfil = async () => {
      try {
        const { data } = await api.get(`${backendPort}/api/main/mt_profil`);
        const rows = Array.isArray(data) ? data : [];
        const mapped = {};
        rows.forEach((row) => {
          const idMt = String(row?.id_mt || "").trim();
          if (!idMt) return;
          mapped[idMt] = {
            roda: Number(row?.roda || 16),
            cadangan: Number(row?.cadangan || 3),
          };
        });
        setMtProfilMap(mapped);
        const fullMap = {};
        rows.forEach((row) => {
          const idMt = String(row?.id_mt || "").trim();
          if (!idMt) return;
          fullMap[idMt] = row;
        });
        setMtDetailMap(fullMap);
      } catch (err) {
        console.error(err);
        setMtProfilMap({});
        setMtDetailMap({});
      }
    };
    //loadMtProfil();
  }, [resendToken]);

  const openDetailMt = async () => {
    const idMt = String(formTemplate.mt || "").trim();
    if (!idMt) return;
    let row = mtDetailMap?.[idMt] || {};
    try {
      api.cancelPendingRequests({
        group: REQ_GROUP_IRREGULAR_MT_DETAIL_LOAD,
        reason: `refresh mt profil irregular ${idMt}`,
      });
      const { data: rows } = await api.get(`${backendPort}/api/main/mt_profil`, {
        params: { id_mt: idMt },
        requestGroup: REQ_GROUP_IRREGULAR_MT_DETAIL_LOAD,
        timeout: 120000,
      });
      const fetchedRow = Array.isArray(rows) && rows.length > 0 ? rows[0] : null;
      if (fetchedRow && typeof fetchedRow === "object") {
        row = fetchedRow;
        setMtDetailMap((prev) => ({
          ...(prev || {}),
          [idMt]: fetchedRow,
        }));
      }
    } catch (err) {
      if (!api.isCanceledError(err)) {
        console.error("Gagal memuat detail MT irregular:", err);
      }
    }
    setSelectedMtDetail({
      id_mt: row?.id_mt || selectedMt?.id_mt || idMt,
      nopol: row?.nopol || selectedMt?.nopol || "-",
      kode_cabang: row?.kode_cabang || selectedMt?.kode_cabang || formTemplate.kodeCabang || (!isPusat ? actorKodeCabang : ""),
      merk: row?.merk || "-",
      kapasitas: row?.kapasitas || "-",
      kategori: row?.kategori || "-",
      status: row?.status || "-",
      roda: Number(row?.roda || selectedMtProfil?.roda || selectedMt?.roda || 0),
      cadangan: Number(row?.cadangan || selectedMtProfil?.cadangan || selectedMt?.cadangan || 0),
      tahun_pembuatan: row?.tahun_pembuatan || "",
      kir: row?.kir || "",
      odo_awal: row?.odo_awal || 0,
      catatan_mt: row?.catatan_mt || "",
      tanggal: row?.tanggal || "",
      user: row?.user || actorNama || "",
      lampiran: Array.isArray(row?.lampiran) ? row.lampiran : [],
      lampiran_mt_event: row?.lampiran_mt_event || ""
    });
    setShowDetailMtPage(true);
  };

  useEffect(() => {
    const loadNomorStoring = async () => {
      if (activeAction !== "storing") return;
      const kodeCabang = String(formTemplate.kodeCabang || (!isPusat ? actorKodeCabang : "")).trim();
      const tanggal = String(formTemplate.tanggal || todayKey);
      setFormTemplate((prev) => ({
        ...prev,
        nomor: buildNomorPreviewPlaceholder({
          kodeCabang,
          prefix: "STOR",
          tanggal,
        }),
      }));
    };
    loadNomorStoring();
  }, [activeAction, actorKodeCabang, formTemplate.kodeCabang, formTemplate.tanggal, todayKey, resendToken]);

  useEffect(() => {
    const loadNomorMemo = async () => {
      if (activeAction !== "ubah_seri") return;
      const kodeCabang = String(ubahIdForm.kodeCabang || "").trim();
      const tanggal = String(ubahIdForm.tanggal || todayKey);
      setUbahIdForm((prev) => ({
        ...prev,
        noMemo: buildNomorPreviewPlaceholder({
          kodeCabang,
          prefix: "MEMO",
          tanggal,
        }),
      }));
    };
    loadNomorMemo();
  }, [activeAction, ubahIdForm.kodeCabang, ubahIdForm.tanggal, todayKey, resendToken]);

  useEffect(() => {
    const loadNomorMemoGantiOdo = async () => {
      if (activeAction !== "ganti_odo") return;
      const kodeCabang = String(gantiOdoForm.kodeCabang || "").trim();
      const tanggal = String(gantiOdoForm.tanggal || todayKey);
      setGantiOdoForm((prev) => ({
        ...prev,
        noMemo: buildNomorPreviewPlaceholder({
          kodeCabang,
          prefix: "MEMO",
          tanggal,
        }),
      }));
    };
    loadNomorMemoGantiOdo();
  }, [activeAction, gantiOdoForm.kodeCabang, gantiOdoForm.tanggal, todayKey, resendToken]);

  useEffect(() => {
    const loadGantiOdoBaseData = async () => {
      if (activeAction !== "ganti_odo") return;
      const idMt = String(gantiOdoForm.selectedMt?.id_mt || "").trim();
      if (!idMt) {
        setGantiOdoForm((prev) => ({
          ...prev,
          odoLastCheck: 0,
          odoLastCheckTgl: "",
          lastKmTempuh: 0,
          lastTdCheckTgl: "",
          lastTdCheckReady: false,
          tdTerpasangCount: 0,
          tdCadanganCount: 0,
          odoLepas: 0,
          odoPasang: 0,
          odoSaatIni: 0,
        }));
        return;
      }
      try {
        const { data: lastCheckRaw } = await api.get(`${backendPort}/api/main/load_last_check/${idMt}`);
        const { data: lastCheckOdoRaw } = await api.get(`${backendPort}/api/main/load_last_check_odo_ganti_odo/${idMt}`);
        const lastCheck = (lastCheckRaw && typeof lastCheckRaw === "object") ? lastCheckRaw : {};
        const lastCheckOdo = (lastCheckOdoRaw && typeof lastCheckOdoRaw === "object") ? lastCheckOdoRaw : {};
        const odoRow = (lastCheck.mt_odo && typeof lastCheck.mt_odo === "object") ? lastCheck.mt_odo : null;
        const odoRowGantiOdo = (lastCheckOdo.mt_odo && typeof lastCheckOdo.mt_odo === "object") ? lastCheckOdo.mt_odo : null;
        const kmtdRows = Array.isArray(lastCheck.ban_last_kmtd) ? lastCheck.ban_last_kmtd : [];
        const lastOdoFromEvent = Number(odoRowGantiOdo?.odo ?? odoRow?.odo ?? 0);
        const lastOdoDate = String(odoRowGantiOdo?.tanggal || odoRow?.tanggal || "").trim();
        const lastKmtMt = Number(odoRowGantiOdo?.kmt_mt ?? odoRow?.kmt_mt ?? 0);

        const daftarBanObj = parseDaftarBan(odoRow?.daftar_ban || {});
        const posisiEntries = Object.entries(daftarBanObj || {});
        const tdTerpasangCount = posisiEntries.filter(([pos, idBan]) => (
          String(pos || "").toUpperCase().startsWith("P-") && Number(idBan) > 0
        )).length;
        const tdCadanganCount = posisiEntries.filter(([pos, idBan]) => (
          String(pos || "").toUpperCase().startsWith("S-") && Number(idBan) > 0
        )).length;
        const activeBanIds = Object.entries(daftarBanObj || {})
          .filter(([pos, idBan]) => String(pos || "").toUpperCase().startsWith("P-") && Number(idBan) > 0)
          .map(([, idBan]) => Number(idBan));

        let tdLastReady = false;
        let tdOldestDate = "";
        if (activeBanIds.length) {
          const kmtdById = {};
          kmtdRows.forEach((row) => {
            const idBan = Number(row?.id_ban || 0);
            if (!idBan || kmtdById[idBan]) return;
            kmtdById[idBan] = row;
          });
          const dates = activeBanIds
            .map((idBan) => String(kmtdById[idBan]?.tgltd || kmtdById[idBan]?.tgl || "").trim())
            .filter(Boolean);
          tdOldestDate = dates.sort()[0] || "";
          tdLastReady = activeBanIds.every((idBan) => {
            const dateKey = formatDateKey(kmtdById[idBan]?.tgltd || kmtdById[idBan]?.tgl || "");
            return Boolean(dateKey && dateKey === todayKey);
          });
        }

        const memoTgl = String(gantiOdoForm.tanggal || todayKey);
        setGantiOdoForm((prev) => ({
          ...prev,
          odoLastCheck: lastOdoFromEvent,
          odoLastCheckTgl: lastOdoDate,
          lastKmTempuh: lastKmtMt,
          lastTdCheckTgl: tdOldestDate,
          lastTdCheckReady: tdLastReady,
          tdTerpasangCount,
          tdCadanganCount,
          odoLepas: lastOdoFromEvent,
          odoLepasTgl: prev.odoLepasTgl || memoTgl,
          odoPasang: 0,
          odoPasangTgl: prev.odoPasangTgl || memoTgl,
          odoSaatIni: 0,
          odoSaatIniTgl: prev.odoSaatIniTgl || memoTgl,
        }));
      } catch (err) {
        console.error(err);
        setGantiOdoForm((prev) => ({
          ...prev,
          odoLastCheck: 0,
          odoLastCheckTgl: "",
          lastKmTempuh: 0,
          lastTdCheckTgl: "",
          lastTdCheckReady: false,
          tdTerpasangCount: 0,
          tdCadanganCount: 0,
          odoLepas: 0,
          odoPasang: 0,
          odoSaatIni: 0,
        }));
      }
    };
    loadGantiOdoBaseData();
  }, [activeAction, gantiOdoForm.selectedMt, gantiOdoForm.tanggal, todayKey, resendToken]);

  useEffect(() => {
    if (activeAction !== "ganti_odo") return;
    if (gantiOdoMode !== "refresh_odo") return;
    setGantiOdoForm((prev) => ({
      ...prev,
      odoLepas: gantiOdoMaxByLastCheck,
      odoPasang: 0,
      odoSaatIni: Number(prev.odoSaatIni || 0),
    }));
  }, [activeAction, gantiOdoMode, gantiOdoMaxByLastCheck]);

  useEffect(() => {
    const loadStoringLastCheck = async () => {
      if (activeAction !== "storing" || !formTemplate.mt) {
        setStoringLastCheck({
          loading: false,
          odo: { value: 0, date: "" },
          td: { terpasang: 0, cadangan: 0, total: 0, oldestDate: "" },
          today: { odo: false, td: false },
        });
        return;
      }
      setStoringLastCheck((prev) => ({ ...prev, loading: true }));
      try {
        const idMt = String(formTemplate.mt || "").trim();
        const { data: lastCheckRaw } = await api.get(`${backendPort}/api/main/load_last_check/${idMt}`);
        const lastCheck = (lastCheckRaw && typeof lastCheckRaw === "object") ? lastCheckRaw : {};
        const odoRow = (lastCheck.mt_odo && typeof lastCheck.mt_odo === "object") ? lastCheck.mt_odo : null;
        const kmtdRows = Array.isArray(lastCheck.ban_last_kmtd) ? lastCheck.ban_last_kmtd : [];
        const daftarBanObj = parseDaftarBan(odoRow?.daftar_ban || {});
        const posisiEntries = Object.entries(daftarBanObj || {});
        const terpasangCount = posisiEntries.filter(([pos, idBan]) => (
          String(pos || "").toUpperCase().startsWith("P-") && Number(idBan) > 0
        )).length;
        const cadanganCount = posisiEntries.filter(([pos, idBan]) => (
          String(pos || "").toUpperCase().startsWith("S-") && Number(idBan) > 0
        )).length;
        const banIds = [...new Set(posisiEntries.map(([, idBan]) => Number(idBan || 0)).filter((x) => x > 0))];
        const kmtdById = {};
        kmtdRows.forEach((row) => {
          const idBan = Number(row?.id_ban || 0);
          if (!idBan || kmtdById[idBan]) return;
          kmtdById[idBan] = row;
        });
        const tdDates = banIds
          .map((idBan) => formatDateKey(kmtdById[idBan]?.tgltd || kmtdById[idBan]?.tgl || ""))
          .filter(Boolean);
        const tdOldestDate = tdDates.length ? tdDates.sort()[0] : "";
        const odoDate = formatDateKey(odoRow?.tanggal || "");
        const odoToday = Boolean(odoDate && odoDate === todayKey);
        const tdToday = tdDates.length > 0 ? tdDates.every((x) => x === todayKey) : false;

        setStoringLastCheck({
          loading: false,
          odo: {
            value: Number(odoRow?.odo || 0),
            date: odoDate,
          },
          td: {
            terpasang: terpasangCount,
            cadangan: cadanganCount,
            total: terpasangCount + cadanganCount,
            oldestDate: tdOldestDate,
          },
          today: {
            odo: odoToday,
            td: tdToday,
          },
        });
      } catch (err) {
        console.error(err);
        setStoringLastCheck({
          loading: false,
          odo: { value: 0, date: "" },
          td: { terpasang: 0, cadangan: 0, total: 0, oldestDate: "" },
          today: { odo: false, td: false },
        });
      }
    };
    loadStoringLastCheck();
  }, [activeAction, formTemplate.mt, todayKey, storingCheckRefreshTick, resendToken]);

  useEffect(() => {
    const loadStoringBanData = async () => {
      if (activeAction !== "storing" || !formTemplate.mt) {
        setStoringBanData({ loading: false, daftarKodeBan: {}, banDetails: {}, banEventMap: {} });
        setSelectedPosisi([]);
        setActiveModalPosisi("");
        setActiveCardPosisi("");
        setShowTambalDetailModal(false);
        setActiveTambalDetailPosisi("");
        setBanActionMap({});
        return;
      }
      setStoringBanData({ loading: true, daftarKodeBan: {}, banDetails: {}, banEventMap: {} });
      try {
        const { data: daftarBanRaw } = await api.get(`${backendPort}/api/main/load_daftarkodeban/${formTemplate.mt}`);
        const daftarBanObj = parseDaftarBan(daftarBanRaw);
        const posisiEntries = Object.entries(daftarBanObj || {}).sort((a, b) => a[0].localeCompare(b[0]));
        const banIds = [...new Set(posisiEntries.map(([, idBan]) => Number(idBan)).filter((x) => x > 0))];
        let banRows = [];
        let kmtdRows = [];
        let eventRows = [];
        if (banIds.length) {
          const [banRes, kmtdRes, eventRes] = await Promise.all([
            api.post(`${backendPort}/api/main/load_daftarBanThisMT_initial`, { kodeBan: banIds }),
            api.post(`${backendPort}/api/main/load_last_kmtd_by_ban`, { kodeBan: banIds }),
            api.post(`${backendPort}/api/main/load_ban_event_history_by_ban`, { kodeBan: banIds }),
          ]);
          banRows = Array.isArray(banRes?.data) ? banRes.data : [];
          kmtdRows = Array.isArray(kmtdRes?.data) ? kmtdRes.data : [];
          eventRows = Array.isArray(eventRes?.data) ? eventRes.data : [];
        }

        const banById = {};
        banRows.forEach((row) => {
          const idBan = Number(row?.id_ban || 0);
          if (!idBan || banById[idBan]) return;
          banById[idBan] = row;
        });
        const kmtdById = {};
        kmtdRows.forEach((row) => {
          const idBan = Number(row?.id_ban || 0);
          if (!idBan || kmtdById[idBan]) return;
          kmtdById[idBan] = row;
        });
        const banEventMap = {};
        eventRows.forEach((row) => {
          const idBan = Number(row?.id_ban || 0);
          if (!idBan) return;
          if (!banEventMap[idBan]) banEventMap[idBan] = [];
          banEventMap[idBan].push(row);
        });

        const banDetails = {};
        const daftarKodeBan = {};
        posisiEntries.forEach(([posisi, idBan]) => {
          const idBanNum = Number(idBan || 0);
          const ban = banById[idBanNum] || {};
          const kmtd = kmtdById[idBanNum] || {};
          const events = banEventMap[idBanNum] || [];
          const lastEvent = events[0] || {};
          banDetails[posisi] = {
            posisi,
            idBan: idBanNum,
            seri: ban?.seri_ban || "-",
            merk: ban?.merk || "-",
            td: kmtd?.td || ban?.td || "-",
            kmt: Number(kmtd?.kmt || 0),
            status: lastEvent?.status || "-",
            kondisi: lastEvent?.kondisi || "-",
            histori: events,
          };
          daftarKodeBan[posisi] = idBanNum;
        });

        setStoringBanData({
          loading: false,
          daftarKodeBan,
          banDetails,
          banEventMap,
        });
      } catch (err) {
        console.error(err);
        setStoringBanData({ loading: false, daftarKodeBan: {}, banDetails: {}, banEventMap: {} });
      }
    };
    loadStoringBanData();
  }, [activeAction, formTemplate.mt, resendToken]);

  useEffect(() => {
    if (activeAction !== "storing") return;
    const detailMap = storingBanData?.banDetails || {};
    const validPosisiSet = new Set(
      Object.entries(detailMap)
        .filter(([, detail]) => Number(detail?.idBan || 0) > 0)
        .map(([pos]) => String(pos || ""))
        .filter(Boolean)
    );
    const hasInvalidSelected = (Array.isArray(selectedPosisi) ? selectedPosisi : [])
      .some((pos) => !validPosisiSet.has(String(pos || "")));
    if (!hasInvalidSelected) return;

    const nextSelectedPosisi = (Array.isArray(selectedPosisi) ? selectedPosisi : [])
      .map((pos) => String(pos || ""))
      .filter((pos) => validPosisiSet.has(pos));
    const nextSelectedSet = new Set(nextSelectedPosisi);

    setSelectedPosisi(nextSelectedPosisi);
    setBanActionMap((prev) => {
      const next = {};
      Object.keys(prev || {}).forEach((pos) => {
        if (nextSelectedSet.has(String(pos || ""))) next[pos] = prev[pos];
      });
      return next;
    });
    setActiveModalPosisi((prev) => (nextSelectedSet.has(String(prev || "")) ? prev : (nextSelectedPosisi[0] || "")));
    setActiveCardPosisi((prev) => (nextSelectedSet.has(String(prev || "")) ? prev : (nextSelectedPosisi[0] || "")));
  }, [activeAction, storingBanData?.banDetails, selectedPosisi]);

  const togglePosisiBan = (posisi) => {
    const pos = String(posisi || "");
    const detail = storingBanData.banDetails?.[pos];
    if (!detail?.idBan) return;

    setSelectedPosisi((prev) => {
      const exists = prev.includes(pos);
      if (exists) {
        const next = prev.filter((x) => x !== pos);
        setActiveModalPosisi((old) => (old === pos ? (next[0] || "") : old));
        setActiveCardPosisi((old) => (old === pos ? (next[0] || "") : old));
        setBanActionMap((oldMap) => {
          const cloned = { ...oldMap };
          delete cloned[pos];
          return cloned;
        });
        return next;
      }
      setActiveModalPosisi(pos);
      setActiveCardPosisi((old) => old || pos);
      const statusBefore = String(detail?.status || "").trim();
      const statusAfterDefault = String(getTambalStatusOptions(statusBefore)?.[0] || statusBefore || "").trim();
      setBanActionMap((oldMap) => ({
        ...oldMap,
        [pos]: oldMap[pos] || {
          status_before: statusBefore,
          status_after: statusAfterDefault,
          catatan: "",
          qty_tambal: 0,
          jenis_tambal: "",
          bahan_tambal: "",
        },
      }));
      return [...prev, pos];
    });
  };

  const updateBanAction = (posisi, field, value) => {
    const pos = String(posisi || "");
    if (!pos) return;
    setBanActionMap((prev) => ({
      ...prev,
      [pos]: {
        ...(prev[pos] || {
          status_before: "",
          status_after: "",
          catatan: "",
          qty_tambal: 0,
          jenis_tambal: "",
          bahan_tambal: "",
        }),
        [field]: value,
      },
    }));
  };

  const handleSubmitTemplate = async (zeroOdoConfirmed = false) => {
    if (selectedAction?.value === "ganti_odo") {
      if (isSubmittingGantiOdo) return;
      setSubmitAttemptedGantiOdo(true);
      if (!isGantiOdoReadyForVerify) {
        showNotif("error", "Lengkapi data Ganti ODO dan pastikan Last TD Check sudah valid hari ini.");
        return;
      }
      if (!isGantiOdoLepasPasangDateValid) {
        showNotif(
          "error",
          "Tanggal ODO Lepas dan ODO Pasang harus sama, serta berada di antara tanggal ODO Last Check dan ODO Saat Ini."
        );
        return;
      }
      if (gantiOdoMode === "ganti_odo") {
        if (Number(gantiOdoForm.odoLepas || 0) < Number(gantiOdoForm.odoLastCheck || 0)) {
          showNotif("error", "ODO Lepas tidak boleh lebih kecil dari ODO Last Check.");
          return;
        }
        if (Number(gantiOdoForm.odoSaatIni || 0) < Number(gantiOdoForm.odoPasang || 0)) {
          showNotif("error", "ODO Saat Ini harus lebih besar atau sama dengan ODO Pasang.");
          return;
        }
        //if (Number(gantiOdoForm.odoPasang || 0) < Number(gantiOdoForm.odoLepas || 0)) {
        //  showNotif("error", "ODO Baru harus lebih besar atau sama dengan ODO Lama.");
        //  return;
        //}
        //if (gantiOdoSelisihKm > 0) {
        //  showNotif("error", "Selisih KM untuk mode GANTI harus <= 0.");
        //  return;
        //}
      } else if (gantiOdoMode === "refresh_odo") {
        if (Number(gantiOdoForm.odoSaatIni || 0) < 0) {
          showNotif("error", "ODO Saat Ini harus lebih besar dari 0.");
          return;
        }
        if (Number(gantiOdoForm.odoSaatIni || 0) < Number(gantiOdoForm.odoPasang || 0)) {
          showNotif("error", "ODO Saat Ini harus lebih besar atau sama dengan ODO Pasang.");
          return;
        }
        if (gantiOdoSelisihKm < 0) {
          showNotif("error", "Selisih KM untuk mode REFRESH harus >= 0.");
          return;
        }
      } else if (gantiOdoMode === "koreksi_odo") {
        if (Number(gantiOdoForm.odoSaatIni || 0) < Number(gantiOdoForm.odoPasang || 0)) {
          showNotif("error", "ODO Saat Ini harus lebih besar atau sama dengan ODO Pasang.");
          return;
        }
        if (gantiOdoSelisihKm < 0) {
          showNotif("error", "Selisih KM untuk mode KOREKSI harus >= 0.");
          return;
        }
      }
      if (!isGantiOdoSelisihLimitValid) {
        showNotif("error", `Selisih KM melebihi batas 2000 KM/hari (maks ${Number(gantiOdoMaxSelisihKm || 0).toLocaleString("id-ID")} KM untuk ${gantiOdoSelisihHari} hari).`);
        return;
      }
      if (!String(gantiOdoForm.namaUser || "").trim()) {
        showNotif("error", "Nama user pemeriksa wajib diisi.");
        return;
      }
      const invalidGantiOdoCaptions = (Array.isArray(attachmentsGantiOdo) ? attachmentsGantiOdo : [])
        .map((att, idx) => (String(att?.caption || "").trim() ? -1 : idx))
        .filter((idx) => idx >= 0);
      if (gantiOdoAttachmentCount <= 0) {
        showNotif("error", "Upload dokumen wajib diisi.");
        return;
      }
      if (invalidGantiOdoCaptions.length > 0) {
        setInvalidCaptionIndexesGantiOdo(invalidGantiOdoCaptions);
        showNotif("error", "Caption dokumen wajib diisi untuk semua lampiran.");
        return;
      }
      const needsGantiOdoZeroConfirmation = gantiOdoMode === "ganti_odo"
        && (Number(gantiOdoForm.odoPasang || 0) === 0 || Number(gantiOdoForm.odoSaatIni || 0) === 0);
      const needsRefreshOdoZeroConfirmation = gantiOdoMode === "refresh_odo"
        && Number(gantiOdoForm.odoSaatIni || 0) === 0;
      const needsZeroOdoConfirmation = needsGantiOdoZeroConfirmation || needsRefreshOdoZeroConfirmation;
      if (needsZeroOdoConfirmation && !zeroOdoConfirmed) {
        if (needsRefreshOdoZeroConfirmation) setShowRefreshOdoZeroConfirmModal(true);
        else setShowGantiOdoZeroConfirmModal(true);
        return;
      }
      try {
        setIsSubmittingGantiOdo(true);
        const formData = new FormData();
        formData.append("id_mt", String(gantiOdoForm.selectedMt?.id_mt || "").trim());
        formData.append("kode_cabang", String(gantiOdoForm.kodeCabang || (!isPusat ? actorKodeCabang : "")).trim());
        formData.append("tanggal", String(gantiOdoForm.tanggal || todayKey));
        formData.append("nomorMemo", String(gantiOdoForm.noMemo || "").trim());
        formData.append("alasan", String(gantiOdoForm.alasan || "").trim());
        formData.append("odo_lepas", String(Number(gantiOdoForm.odoLepas || 0)));
        formData.append("odo_pasang", String(Number(gantiOdoForm.odoPasang || 0)));
        formData.append("odo_baru", String(Number(gantiOdoForm.odoSaatIni || 0)));
        formData.append("tgl_lepas", String(gantiOdoForm.odoLepasTgl || gantiOdoForm.tanggal || todayKey));
        formData.append("tgl_pasang", String(gantiOdoForm.odoPasangTgl || gantiOdoForm.tanggal || todayKey));
        formData.append("tgl_odo_baru", String(gantiOdoForm.odoSaatIniTgl || gantiOdoForm.tanggal || todayKey));
        formData.append("selisih_km", String(Number(gantiOdoSelisihKm || 0)));
        formData.append("km_tempuh", String(Number(gantiOdoKmTempuh || 0)));
        formData.append("check_validasi_mt", "true");
        formData.append("nama_pemeriksa_mt", String(gantiOdoForm.namaUser || "").trim());
        formData.append("jenis_odo", gantiOdoMode);
        formData.append("zero_odo_confirmed", needsZeroOdoConfirmation ? "true" : "false");
        formData.append("user", actorNama);

        attachmentsGantiOdo.forEach((item) => {
          if (item?.file instanceof File) formData.append("files", item.file);
          formData.append("captions", item?.caption || "");
        });
        const existingLampiran = attachmentsGantiOdo
          .filter((item) => !(item?.file instanceof File))
          .map((item) => ({
            name: item?.name || "",
            file: item?.db_file || item?.file || "",
            path: item?.path || "",
            type: item?.type || "",
            size: Number(item?.size || 0),
            caption: item?.caption || "",
            uploaded_at: item?.uploaded_at || null,
          }));
        formData.append("existing_lampiran", JSON.stringify(existingLampiran));

        const { data } = await api.post(`${backendPort}/api/main/submit_ganti_odo_mt`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        showNotif("success", data?.message || "Penggantian ODO berhasil disimpan.");
        handlePilihAction("ganti_odo");
      } catch (err) {
        console.error(err);
        showNotif("error", err?.response?.data?.message || "Gagal submit penggantian ODO.");
      } finally {
        setIsSubmittingGantiOdo(false);
      }
      return;
    }

    if (selectedAction?.value === "ubah_seri") {
      if (!isUbahIdValid) {
        showNotif("error", "Lengkapi semua field wajib pada Perubahan ID UNIK sebelum submit.");
        return;
      }
      if (ubahIdAttachmentCount <= 0) {
        showNotif("error", "Upload dokumen wajib diisi.");
        return;
      }
      const invalidUbahIdCaptions = (Array.isArray(attachmentsUbahId) ? attachmentsUbahId : [])
        .map((att, idx) => (String(att?.caption || "").trim() ? -1 : idx))
        .filter((idx) => idx >= 0);
      if (invalidUbahIdCaptions.length > 0) {
        setInvalidCaptionIndexesUbahId(invalidUbahIdCaptions);
        showNotif("error", "Caption dokumen wajib diisi untuk semua lampiran.");
        return;
      }
      try {
        setIsSubmittingUbahId(true);
        const formData = new FormData();
        formData.append("kode_cabang", String(ubahIdForm.kodeCabang || (!isPusat ? actorKodeCabang : "")).trim());
        formData.append("tanggal", String(ubahIdForm.tanggal || todayKey));
        formData.append("nomorMemo", String(ubahIdForm.noMemo || "").trim());
        formData.append("jenisId", String(ubahIdForm.jenisId || "").trim());
        formData.append("alasan", String(ubahIdForm.alasan || "").trim());
        formData.append("check_validasi_mt", "true");
        formData.append("nama_pemeriksa_mt", String(ubahIdForm.namaUser || "").trim());
        formData.append("user", actorNama);

        if (ubahIdForm.jenisId === "nopol") {
          formData.append("id_mt", String(ubahIdForm.selectedMt?.id_mt || "").trim());
          formData.append("nopol_lama", String(ubahIdForm.nopolLama || "").trim());
          formData.append("nopol_baru", String(ubahIdForm.nopolBaru || "").trim());
        } else {
          formData.append("id_ban", String(Number(ubahIdForm.selectedBan?.id_ban || 0)));
          formData.append("seri_lama", String(ubahIdForm.seriSementara || "").trim());
          formData.append("seri_baru", String(ubahIdForm.seriBaru || "").trim());
        }

        attachmentsUbahId.forEach((item) => {
          if (item?.file instanceof File) formData.append("files", item.file);
          formData.append("captions", item?.caption || "");
        });
        const existingLampiran = attachmentsUbahId
          .filter((item) => !(item?.file instanceof File))
          .map((item) => ({
            name: item?.name || "",
            file: item?.db_file || item?.file || "",
            path: item?.path || "",
            type: item?.type || "",
            size: Number(item?.size || 0),
            caption: item?.caption || "",
            uploaded_at: item?.uploaded_at || null,
          }));
        formData.append("existing_lampiran", JSON.stringify(existingLampiran));

        const { data } = await api.post(`${backendPort}/api/main/submit_perubahan_id_unik`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        showNotif("success", data?.message || "Perubahan ID unik berhasil disimpan.");
        try {
          await manualResyncGlobalOpsi({ requestGroup: "irregular-change-id-unik" });
        } catch (refreshErr) {
          console.error(refreshErr);
        }
        handlePilihAction("ubah_seri");
      } catch (err) {
        console.error(err);
        showNotif("error", err?.response?.data?.message || "Gagal submit perubahan ID unik.");
      } finally {
        setIsSubmittingUbahId(false);
      }
      return;
    }
    if (selectedAction?.value !== "storing") {
      showNotif("info", "Panel ini masih template dan akan disempurnakan di iterasi berikutnya.");
      return;
    }
    if (isSubmittingStoring) return;
    if (String(storingForm.jenis || "").trim() === "rotasi") {
      showNotif("info", "Jenis storing Rotasi diproses melalui Modal Rotasi.");
      handleOpenStoringRotasiModal();
      return;
    }
    if (!formTemplate.mt || !storingForm.jenis || !storingForm.jarak) {
      showNotif("error", "Lengkapi data storing: MT, jenis storing, dan perkiraan jarak.");
      return;
    }
    if (!storingForm.lokasi || !storingForm.start || !storingForm.end) {
      showNotif("error", "Lengkapi data storing: lokasi, waktu mulai, dan waktu selesai.");
      return;
    }
    if (!selectedTambalBanRows.length) {
      showNotif("error", "Pilih minimal 1 ban terdampak.");
      return;
    }
    const adaBanBelumLengkap = selectedTambalBanRows.some((row) => !isBanActionComplete(row));
    if (adaBanBelumLengkap) {
      showNotif("error", "Lengkapi status dan detail tambal untuk semua ban tambal.");
      return;
    }
    if (!storingLastCheck?.today?.odo || !storingLastCheck?.today?.td) {
      showNotif("error", "Submit belum bisa dilanjutkan karena Last Check ODO/TD belum update per hari ini.");
      return;
    }
    const invalidStoringCaptions = (Array.isArray(attachments) ? attachments : [])
      .map((att, idx) => (String(att?.caption || "").trim() ? -1 : idx))
      .filter((idx) => idx >= 0);
    if (invalidStoringCaptions.length > 0) {
      setInvalidCaptionIndexesStoring(invalidStoringCaptions);
      showNotif("error", "Caption dokumen wajib diisi untuk semua lampiran.");
      return;
    }

    const banTerdampak = selectedTambalBanRows.map((row) => ({
      posisi: String(row?.posisi || "").trim(),
      id_ban: Number(row?.id_ban || 0),
      tindakan: "tambal",
      catatan: String(row?.catatan || "").trim(),
      qty_tambal: Number(row?.qty_tambal || 0),
      jenis_tambal: String(row?.jenis_tambal || "").trim(),
      bahan_tambal: String(row?.bahan_tambal || "").trim(),
      status_lama: String(row?.status_before || "").trim(),
      status_baru: String(row?.status_after || "").trim(),
    }));
    const invalidBan = banTerdampak.find((item) => (
      !item.posisi
      || item.id_ban <= 0
      || !String(item.status_baru || "").trim()
      || !String(item.jenis_tambal || "").trim()
      || !Number.isFinite(Number(item.qty_tambal))
      || Number(item.qty_tambal) < 0
      || Number(item.qty_tambal) > 4
    ));
    if (invalidBan) {
      showNotif("error", "Data ban terdampak belum valid. Pilih ulang ban yang bermasalah.");
      return;
    }

    try {
      setIsSubmittingStoring(true);
      const formData = new FormData();
      const kodeCabangStoring = String(formTemplate.kodeCabang || (!isPusat ? actorKodeCabang : "")).trim();
      formData.append("id_mt", String(formTemplate.mt || "").trim());
      formData.append("tanggal", String(formTemplate.tanggal || todayKey));
      formData.append("kode_cabang", kodeCabangStoring);
      formData.append("jenis", String(storingForm.jenis || "").trim());
      formData.append("lokasi", String(storingForm.lokasi || "").trim());
      formData.append("start", String(storingForm.start || "").trim());
      formData.append("end", String(storingForm.end || "").trim());
      formData.append("jarak", String(storingForm.jarak || "").trim());
      formData.append("nama_pemeriksa_mt", String(namaPemeriksaStoring || "").trim());
      formData.append("ban_terdampak", JSON.stringify(banTerdampak));
      formData.append("user", actorNama);

      attachments.forEach((item) => {
        if (item?.file instanceof File) formData.append("files", item.file);
        formData.append("captions", item?.caption || "");
      });
      const existingLampiran = attachments
        .filter((item) => !(item?.file instanceof File))
        .map((item) => ({
          name: item?.name || "",
          file: item?.db_file || item?.file || "",
          path: item?.path || "",
          type: item?.type || "",
          size: Number(item?.size || 0),
          caption: item?.caption || "",
          uploaded_at: item?.uploaded_at || null,
        }));
      formData.append("existing_lampiran", JSON.stringify(existingLampiran));

      const { data } = await api.post(`${backendPort}/api/main/submit_storing_mt`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      showNotif("success", data?.message || "Storing berhasil disimpan.");
      handlePilihAction("storing");
    } catch (err) {
      console.error(err);
      showNotif("error", err?.response?.data?.message || "Gagal submit storing.");
    } finally {
      setIsSubmittingStoring(false);
    }
  };

  return (
    <div className="container-fluid px-0 page16-wo-elegant-theme page26-irregular-theme page16-wo2-table-theme">
      {!isStoringOnlyScope && (
        <div className="page16-header d-flex justify-content-between align-items-start flex-wrap gap-2 mb-4">
          <div>
            <h3 className="page16-title">Irregular Event</h3>
          </div>
        </div>
      )}

      <div className="row g-4">
        {!isStoringOnlyScope && (
          <div className="col-12 col-md-4">
            <div className="page16-action-grid">
              <div className="row g-2">
                {irregularActions.map((action) => (
                  <div key={action.value} className="col-12">
                    <button
                      type="button"
                      className={`page15-odotd-action ${activeAction === action.value ? "is-active" : ""}`}
                      onClick={() => handlePilihAction(action.value)}
                    >
                      <div className="d-flex justify-content-between align-items-start gap-2">
                        <div>
                          <h5 className="mb-1 text-white">{action.title}</h5>
                          <p className="mb-0 text-white-80 small">{action.description}</p>
                        </div>
                        <span className="page16-action-state text-white">
                          {activeAction === action.value ? "Aktif" : "Pilih"}
                        </span>
                      </div>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        <div className={isStoringOnlyScope ? "col-12" : "col-12 col-md-8"}>
          <div className={`${selectedAction ? "page16-panel-form h-100" : ""} ${panelAccentClassByIrregularAction(selectedAction?.value)}`}>
            {!selectedAction && (
              <div className="page16-panel-placeholder d-flex flex-column justify-content-center align-items-center text-center h-100">
                <p className="fw-semibold mb-1">Belum ada menu dipilih.</p>
                <p className="text-muted small mb-0">Klik salah satu menu di sebelah kiri untuk membuka panel.</p>
              </div>
            )}

            {selectedAction && (
              <div>
                <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-3">
                  <div>
                    <p className="page16-panel-label mb-1">Detail Aktivitas</p>
                    <h4 className="page16-panel-title mb-1">{selectedAction.title}</h4>
                    <p className="text-muted small mb-0">{selectedAction.description}</p>
                  </div>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary page16-panel-close"
                    onClick={() => setActiveAction("")}
                    aria-label="Tutup panel"
                  >
                    <i className="fa fa-times" aria-hidden="true" />
                  </button>
                </div>

                <div className="row g-3">
                  {selectedAction.value === "storing" ? (
                    <>
                      <div className="col-12 col-lg-4">
                        <label className="form-label">Cabang</label>
                        {!isPusat ? (
                          <input className="form-control" value={namaCabangUser || "-"} readOnly />
                        ) : (
                          <select
                            className={`form-select ${invalidStoringCabang ? "field-required-invalid" : ""}`}
                            value={formTemplate.kodeCabang}
                            onChange={(e) =>
                              setFormTemplate((prev) => ({
                                ...prev,
                                kodeCabang: e.target.value,
                                mt: "",
                                nomor: NOMOR_PREVIEW_PLACEHOLDER,
                              }))
                            }
                          >
                            <option value="">-Pilih Cabang-</option>
                            {opsiCabang.map((x) => (
                              <option key={x.kode_cabang} value={x.kode_cabang}>
                                {x.nama_cabang}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>
                      <div className="col-12 col-lg-4">
                        <label className="form-label">No Storing</label>
                        <input className="form-control" value={formTemplate.nomor || "-"} readOnly />
                      </div>
                      <div className="col-12 col-lg-4">
                        <label className="form-label">Tanggal</label>
                        <input
                          type="date"
                          className="form-control"
                          value={formTemplate.tanggal || todayKey}
                          readOnly
                        />
                      </div>

                      <div className="col-12 col-lg-4">
                        <label className="form-label">No. Pol</label>
                        <input
                          type="text"
                          className={`form-control ${invalidStoringMt ? "field-required-invalid" : ""}`}
                          readOnly
                          style={{ cursor: "pointer" }}
                          placeholder="Pilih NoPol"
                          value={selectedMt?.nopol || ""}
                          onClick={() => {
                            if (isPusat && !String(formTemplate.kodeCabang || "").trim()) {
                              showNotif("error", "Pilih cabang terlebih dahulu.");
                              return;
                            }
                            setShowCariMtStoringModal(true);
                          }}
                        />
                      </div>
                      <div className="col-12 col-lg-4">
                        <label className="form-label">Waktu Mulai</label>
                        <input
                          type="time"
                          className={`form-control ${invalidStoringStart ? "field-required-invalid" : ""}`}
                          value={storingForm.start}
                          onChange={(e) => setStoringForm((prev) => ({ ...prev, start: e.target.value }))}
                        />
                      </div>
                      <div className="col-12 col-lg-4">
                        <label className="form-label">Waktu Selesai</label>
                        <input
                          type="time"
                          className={`form-control ${invalidStoringEnd || invalidStoringTimeRange ? "field-required-invalid" : ""}`}
                          value={storingForm.end}
                          onChange={(e) => setStoringForm((prev) => ({ ...prev, end: e.target.value }))}
                        />
                      </div>
                      {invalidStoringTimeRange && (
                        <div className="col-12">
                          <small className="text-danger">Waktu Selesai harus lebih besar dari Waktu Mulai.</small>
                        </div>
                      )}

                      <div className="col-12 col-lg-8">
                        <label className="form-label">Lokasi Storing</label>
                        <input
                          type="text"
                          className={`form-control ${invalidStoringLokasi ? "field-required-invalid" : ""}`}
                          placeholder="Contoh: Tol KM 33 arah barat, bahu jalan kiri..."
                          value={storingForm.lokasi}
                          onChange={(e) => setStoringForm((prev) => ({ ...prev, lokasi: e.target.value }))}
                        />
                      </div>
                      <div className="col-12 col-lg-4">
                        <label className="form-label">Jarak dari Workshop</label>
                        <select
                          className={`form-select ${invalidStoringJarak ? "field-required-invalid" : ""}`}
                          value={storingForm.jarak}
                          onChange={(e) => setStoringForm((prev) => ({ ...prev, jarak: e.target.value }))}
                        >
                          {STORING_DISTANCE_OPTIONS.map((opt) => (
                            <option key={`${opt.value}-${opt.label}`} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </>
                  ) : (selectedAction.value !== "ubah_seri" && selectedAction.value !== "ganti_odo") ? (
                    <>
                      <div className="col-12 col-lg-4">
                        <label className="form-label">Nama Cabang</label>
                        {!isPusat ? (
                          <input className="form-control" value={namaCabangUser || ""} readOnly />
                        ) : (
                          <select
                            className="form-select"
                            value={formTemplate.kodeCabang}
                            onChange={(e) =>
                              setFormTemplate((prev) => ({
                                ...prev,
                                kodeCabang: e.target.value,
                                mt: "",
                              }))
                            }
                          >
                            <option value="">-Pilih Cabang-</option>
                            {opsiCabang.map((x) => (
                              <option key={x.kode_cabang} value={x.kode_cabang}>
                                {x.nama_cabang}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>
                      <div className="col-12 col-lg-4">
                        <label className="form-label">Tanggal</label>
                        <input
                          type="date"
                          className="form-control"
                          value={formTemplate.tanggal || todayKey}
                          onChange={(e) => setFormTemplate((prev) => ({ ...prev, tanggal: e.target.value }))}
                        />
                      </div>
                      <div className="col-12 col-lg-4">
                        <label className="form-label">No. Pol</label>
                        <select
                          className="form-select"
                          value={formTemplate.mt}
                          onChange={(e) => setFormTemplate((prev) => ({ ...prev, mt: e.target.value }))}
                          disabled={!formTemplate.kodeCabang}
                        >
                          <option value="">-Pilih NoPol MT-</option>
                          {opsiMtByCabang.map((x) => (
                            <option key={x.id_mt} value={x.id_mt}>
                              {x.nopol}
                            </option>
                          ))}
                        </select>
                      </div>
                    </>
                  ) : null}
                </div>

                {selectedAction.value === "ubah_seri" && (
                  <div className="row g-3 mt-1">
                    <div className="col-12 col-lg-4">
                      <label className="form-label">Cabang</label>
                      {!isPusat ? (
                        <input className="form-control" value={cabangLabelUbahId} readOnly />
                      ) : (
                      <select
                        className={`form-select ${invalidUbahIdCabang ? "field-required-invalid" : ""}`}
                        value={ubahIdForm.kodeCabang}
                          onChange={(e) => setUbahIdForm((prev) => ({ ...prev, kodeCabang: e.target.value }))}
                        >
                          <option value="">-Pilih Cabang-</option>
                          {opsiCabang.map((x) => (
                            <option key={x.kode_cabang} value={x.kode_cabang}>
                              {x.nama_cabang}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>
                    <div className="col-12 col-lg-4">
                      <label className="form-label">No. Transaksi</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="-"
                        value={ubahIdForm.noMemo}
                        readOnly
                      />
                    </div>
                    <div className="col-12 col-lg-4">
                      <label className="form-label">Tanggal Input</label>
                      <input
                        type="date"
                        className="form-control"
                        value={ubahIdForm.tanggal || todayKey}
                        readOnly
                      />
                    </div>

                    <div className="col-12 col-lg-4">
                      <label className="form-label">Jenis ID</label>
                      <select
                        className={`form-select ${invalidUbahIdJenis ? "field-required-invalid" : ""}`}
                        value={ubahIdForm.jenisId}
                        onChange={(e) => {
                          const nextJenis = e.target.value;
                          const defaultAlasan = "";
                          setUbahIdForm((prev) => ({
                            ...prev,
                            jenisId: nextJenis,
                            alasan: defaultAlasan,
                            selectedMt: null,
                            nopolLama: "",
                            nopolBaru: "",
                            selectedBan: null,
                            seriSementara: "",
                            seriBaru: "",
                          }));
                        }}
                      >
                        <option value="">Pilih Jenis ID</option>
                        <option value="nopol">No. Pol</option>
                        <option value="seri_ban">No. Seri Ban</option>
                      </select>
                    </div>
                    <div className="col-12 col-lg-8">
                      <label className="form-label">Alasan Perubahan</label>
                      <textarea
                        className={`form-control ${invalidUbahIdAlasan ? "field-required-invalid" : ""}`}
                        placeholder="Jelaskan alasan perubahan ID unik..."
                        value={ubahIdForm.alasan}
                        onChange={(e) => setUbahIdForm((prev) => ({ ...prev, alasan: e.target.value }))}
                      />
                    </div>

                    {ubahIdForm.jenisId === "nopol" ? (
                      <>
                        <div className="col-12">
                          <label className="form-label d-block">No. Pol</label>
                          <div className="d-flex align-items-center gap-2 flex-wrap">
                            <button
                              type="button"
                              className="btn btn-outline-primary"
                              onClick={() => {
                                setShowCariMtIdUnikModal(true);
                              }}
                            >
                              Cari MT
                            </button>
                            <span className="text-muted small">
                              {ubahIdForm.selectedMt
                                ? `Terpilih: ${ubahIdForm.selectedMt.nopol || "-"} (${ubahIdForm.selectedMt.id_mt || "-"})`
                                : "Belum ada MT dipilih"}
                            </span>
                          </div>
                        </div>
                        {!!ubahIdForm.selectedMt && (
                          <>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">No Pol Lama</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="No Pol saat ini"
                                value={ubahIdForm.nopolLama}
                                readOnly
                              />
                            </div>
                            <div className="col-12 col-lg-4 d-flex align-items-end">
                              <div className="w-100 text-center text-muted fw-semibold py-2">DIUBAH MENJADI</div>
                            </div>
                            <div className="col-12 col-lg-4">
                              <label className="form-label">No Pol Baru</label>
                              <input
                                type="text"
                                className={`form-control ${invalidUbahIdNopolBaru ? "field-required-invalid" : ""}`}
                                placeholder="Input No Pol baru"
                                value={ubahIdForm.nopolBaru}
                                onChange={(e) => setUbahIdForm((prev) => ({ ...prev, nopolBaru: sanitizeNopolInput(e.target.value) }))}
                              />
                            </div>
                          </>
                        )}
                      </>
                    ) : ubahIdForm.jenisId === "seri_ban" ? (
                      <>
                        <div className="col-12">
                          <label className="form-label d-block">No. Seri Ban</label>
                          <div className="d-flex align-items-center gap-2 flex-wrap">
                            <button
                              type="button"
                              className="btn btn-outline-primary"
                              onClick={() => {
                                setShowCariBanIdUnikModal(true);
                              }}
                            >
                              Cari Ban
                            </button>
                            <span className="text-muted small">
                              {ubahIdForm.selectedBan
                                ? `Terpilih: ID ${ubahIdForm.selectedBan.id_ban || "-"} | ${ubahIdForm.selectedBan.seri_ban || "-"}`
                                : "Belum ada ban dipilih"}
                            </span>
                          </div>
                        </div>
                        {!!ubahIdForm.selectedBan && (
                          <>
                            <div className="col-12 col-lg-6">
                              <label className="form-label">No Seri Ban Sementara</label>
                              <input
                                type="text"
                                className="form-control"
                                value={ubahIdForm.seriSementara}
                                readOnly
                              />
                            </div>
                            <div className="col-12 col-lg-6">
                              <label className="form-label">No Seri Ban Baru</label>
                              <input
                                type="text"
                                className={`form-control ${invalidUbahIdSeriBaru ? "field-required-invalid" : ""}`}
                                value={ubahIdForm.seriBaru}
                                onChange={(e) => setUbahIdForm((prev) => ({ ...prev, seriBaru: sanitizeSeriBanInput(e.target.value) }))}
                              />
                            </div>
                          </>
                        )}
                      </>
                    ) : null}
                  </div>
                )}

                {selectedAction.value === "ganti_odo" && (
                  <div className="row g-3 mt-1">
                    <div className="col-12 col-lg-4">
                      <label className="form-label">Cabang</label>
                      {!isPusat ? (
                        <input className="form-control" value={cabangLabelGantiOdo} readOnly />
                      ) : (
                        <select
                          className={`form-select ${invalidGantiOdoCabang ? "field-required-invalid" : ""}`}
                          value={gantiOdoForm.kodeCabang}
                          onChange={(e) => {
                            const kodeCabang = e.target.value;
                            setGantiOdoForm((prev) => ({
                              ...prev,
                              kodeCabang,
                              selectedMt: null,
                            }));
                          }}
                        >
                          <option value="">-Pilih Cabang-</option>
                          {opsiCabang.map((x) => (
                            <option key={x.kode_cabang} value={x.kode_cabang}>
                              {x.nama_cabang}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>
                    <div className="col-12 col-lg-4">
                      <label className="form-label">No. Transaksi</label>
                      <input className="form-control" value={gantiOdoForm.noMemo || ""} readOnly />
                    </div>
                    <div className="col-12 col-lg-4">
                      <label className="form-label">Tanggal Input</label>
                      <input
                        type="date"
                        className="form-control"
                        value={gantiOdoForm.tanggal || todayKey}
                        readOnly
                      />
                    </div>

                    <div className="col-12 col-lg-4">
                      <label className="form-label">No. Pol</label>
                      <input
                        type="text"
                        className={`form-control ${invalidGantiOdoMt ? "field-required-invalid" : ""}`}
                        readOnly
                        style={{ cursor: "pointer" }}
                        placeholder="Pilih NoPol"
                        value={gantiOdoForm.selectedMt?.nopol || ""}
                        onClick={() => setShowCariMtGantiOdoModal(true)}
                      />
                    </div>
                    <div className="col-12 col-lg-8">
                      <label className="form-label">Alasan Perubahan</label>
                      <input
                        type="text"
                        className={`form-control ${invalidGantiOdoAlasan ? "field-required-invalid" : ""}`}
                        value={gantiOdoForm.alasan}
                        placeholder="Jelaskan alasan perubahan odo.."
                        onChange={(e) => setGantiOdoForm((prev) => ({ ...prev, alasan: e.target.value }))}
                      />
                    </div>

                    <div className="col-12">
                      <div className="card page16-info-card">
                        <div className="card-body">
                          <div className="row g-2 align-items-stretch">
                            <div className="col-12 col-lg-8">
                              <div className="h-100 d-flex flex-column justify-content-center">
                                <small className="fw-semibold">{gantiOdoForm.selectedMt?.nopol || "Belum pilih MT"}</small>
                                <span className="page16-info-title">LAST CHECK TD</span>
                                <small className={gantiOdoForm.lastTdCheckReady ? "fs-6 fw-light fst-italic text-success" : "fs-6 fw-light fst-italic text-danger"}>
                                  Check: {formatDate(gantiOdoForm.lastTdCheckReady ? todayKey : gantiOdoForm.lastTdCheckTgl)}
                                  {" "}
                                  ({dayDiffLabel(gantiOdoForm.lastTdCheckReady ? todayKey : gantiOdoForm.lastTdCheckTgl)})
                                </small>
                              </div>
                            </div>
                            <div className="col-12 col-lg-4">
                              <div className="page16-info-item h-100">
                                <small>TD BAN</small>
                                <button
                                  type="button"
                                  className="btn page16-gradient-btn text-white fw-bold"
                                  disabled={!gantiOdoForm.selectedMt?.id_mt}
                                  onClick={() => setShowTdUpdateModalGantiOdo(true)}
                                >
                                  {`${Number(gantiOdoForm.tdTerpasangCount || 0)} + ${Number(gantiOdoForm.tdCadanganCount || 0)} ban`}
                                </button>
                              </div>
                            </div>
                          </div>
                          {!gantiOdoForm.lastTdCheckReady && (
                            <div className="mt-2">
                              <small className="fst-italic fw-light">
                                Anda belum dapat melanjutkan proses karena data TD ban belum update per hari ini.
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="card page16-soft-card">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center gap-2 mb-3">
                            <div className="page16-info-title mb-0">PENGGANTIAN ODO METER</div>
                            <div className="d-flex flex-wrap gap-2 ms-auto">
                              <button
                                type="button"
                                className={`btn btn-sm ${gantiOdoMode === "ganti_odo" ? "btn-primary" : "btn-outline-primary"}`}
                                onClick={() => setGantiOdoForm((prev) => ({ ...prev, jenis_odo: "ganti_odo" }))}
                              >
                                GANTI
                              </button>
                              <button
                                type="button"
                                className={`btn btn-sm ${gantiOdoMode === "refresh_odo" ? "btn-primary" : "btn-outline-primary"}`}
                                onClick={() => setGantiOdoForm((prev) => ({ ...prev, jenis_odo: "refresh_odo" }))}
                              >
                                REFRESH
                              </button>
                            </div>
                          </div>
                          <div className="d-flex flex-column gap-2">
                            <div className="row g-2 align-items-center">
                              <div className="col-12 col-lg-3"><span>ODO Last Check</span></div>
                              <div className="col-12 col-lg-9 d-flex flex-wrap align-items-center gap-2">
                                <input
                                  type="text"
                                  className="form-control"
                                  style={{ maxWidth: 220 }}
                                  value={Number(gantiOdoForm.odoLastCheck || 0).toLocaleString("id-ID")}
                                  disabled
                                />
                                <span>Tgl.</span>
                                <input
                                  type="text"
                                  className="form-control"
                                  style={{ maxWidth: 220 }}
                                  value={gantiOdoForm.odoLastCheckTgl ? `${formatDate(gantiOdoForm.odoLastCheckTgl)}` : "-"}
                                  disabled
                                />
                              </div>
                            </div>

                            <div className="row g-2 align-items-center">
                              <div className="col-12 col-lg-3"><span>ODO Lepas</span></div>
                              <div className="col-12 col-lg-9 d-flex flex-wrap align-items-center gap-2">
                                <input
                                  type="text"
                                  inputMode="numeric"
                                  className={`form-control ${invalidGantiOdoOdoLepas ? "field-required-invalid" : ""}`}
                                  style={{ maxWidth: 220 }}
                                  value={formatRibuanInput(gantiOdoForm.odoLepas)}
                                  onChange={(e) => setGantiOdoForm((prev) => ({ ...prev, odoLepas: parseRibuanInput(e.target.value) }))}
                                  disabled={gantiOdoMode === "refresh_odo"}
                                />
                                <span>Tgl.</span>
                                <input
                                  type="date"
                                  className={`form-control ${isGantiOdoLepasPasangDateEditable && !isGantiOdoLepasPasangDateValid ? "field-required-invalid" : ""}`}
                                  style={{ maxWidth: 220 }}
                                  value={gantiOdoForm.odoLepasTgl || gantiOdoForm.tanggal || todayKey}
                                  min={gantiOdoLepasPasangMinDate || undefined}
                                  max={gantiOdoLepasPasangMaxDate || undefined}
                                  onChange={(e) => {
                                    const tanggalLepasPasang = e.target.value;
                                    setGantiOdoForm((prev) => ({
                                      ...prev,
                                      odoLepasTgl: tanggalLepasPasang,
                                      odoPasangTgl: tanggalLepasPasang,
                                    }));
                                  }}
                                  disabled={!isGantiOdoLepasPasangDateEditable}
                                />
                              </div>
                            </div>

                            <div className="row g-2 align-items-center">
                              <div className="col-12 col-lg-3"><span>ODO Pasang</span></div>
                              <div className="col-12 col-lg-9 d-flex flex-wrap align-items-center gap-2">
                                <input
                                  type="text"
                                  inputMode="numeric"
                                  className={`form-control ${invalidGantiOdoOdoPasang ? "field-required-invalid" : ""}`}
                                  style={{ maxWidth: 220 }}
                                  value={formatRibuanInput(gantiOdoForm.odoPasang)}
                                  onChange={(e) => {
                                    if (gantiOdoMode === "refresh_odo") return;
                                    const nextOdoPasang = parseRibuanInput(e.target.value);
                                    setGantiOdoForm((prev) => ({ ...prev, odoPasang: nextOdoPasang }));
                                  }}
                                  disabled={gantiOdoMode === "refresh_odo"}
                                />
                                <span>Tgl.</span>
                                <input
                                  type="date"
                                  className={`form-control ${isGantiOdoLepasPasangDateEditable && !isGantiOdoLepasPasangDateValid ? "field-required-invalid" : ""}`}
                                  style={{ maxWidth: 220 }}
                                  value={gantiOdoForm.odoPasangTgl || gantiOdoForm.tanggal || todayKey}
                                  min={gantiOdoLepasPasangMinDate || undefined}
                                  max={gantiOdoLepasPasangMaxDate || undefined}
                                  onChange={(e) => {
                                    const tanggalLepasPasang = e.target.value;
                                    setGantiOdoForm((prev) => ({
                                      ...prev,
                                      odoLepasTgl: tanggalLepasPasang,
                                      odoPasangTgl: tanggalLepasPasang,
                                    }));
                                  }}
                                  disabled={!isGantiOdoLepasPasangDateEditable}
                                />
                              </div>
                            </div>
                            {isGantiOdoLepasPasangDateEditable && !isGantiOdoLepasPasangDateValid && (
                              <div className="row g-2">
                                <div className="col-12 col-lg-3" />
                                <div className="col-12 col-lg-9">
                                  <small className="text-danger">
                                    Tanggal ODO Lepas dan ODO Pasang harus sama, serta berada di antara tanggal ODO Last Check dan ODO Saat Ini.
                                  </small>
                                </div>
                              </div>
                            )}

                            <div className="row g-2 align-items-center">
                              <div className="col-12 col-lg-3"><span>ODO Saat ini</span></div>
                              <div className="col-12 col-lg-9 d-flex flex-wrap align-items-center gap-2">
                                <input
                                  type="text"
                                  inputMode="numeric"
                                  className={`form-control ${invalidGantiOdoOdoSaatIni ? "field-required-invalid" : ""}`}
                                  style={{ maxWidth: 220 }}
                                  value={formatRibuanInput(gantiOdoForm.odoSaatIni)}
                                  onChange={(e) => {
                                    const nextOdoSaatIni = parseRibuanInput(e.target.value);
                                    setGantiOdoForm((prev) => ({
                                      ...prev,
                                      odoSaatIni: nextOdoSaatIni,
                                    }));
                                  }}
                                />
                                <span>Tgl.</span>
                                <input
                                  type="date"
                                  className="form-control"
                                  style={{ maxWidth: 220 }}
                                  value={gantiOdoForm.odoSaatIniTgl || gantiOdoForm.tanggal || todayKey}
                                  readOnly
                                />
                              </div>
                            </div>

                            <div className="row g-2 align-items-top pt-2">
                              <div className="col-12 col-lg-3"><span>Selisih KM</span></div>
                              <div className="col-12 col-lg-9">
                                <input
                                  className={`form-control ${invalidGantiOdoSelisihKm ? "field-required-invalid" : ""}`}
                                  style={{ maxWidth: 220 }}
                                  value={Number(gantiOdoSelisihKm || 0).toLocaleString("id-ID")}
                                  disabled
                                />
                                <small className="text-muted d-block mt-1">
                                  Maks selisih: {Number(gantiOdoMaxSelisihKm || 0).toLocaleString("id-ID")} KM ({gantiOdoSelisihHari} hari)
                                </small>
                              </div>
                            </div>
                            <hr/>
                            <div className="row g-2 align-items-center">
                              <div className="col-12 col-lg-3"><span>KM Tempuh</span></div>
                              <div className="col-12 col-lg-4">
                                <input  className="form-control"
                                        style={{ maxWidth: 220 }}
                                        value={Number(gantiOdoKmTempuh || 0).toLocaleString("id-ID")}
                                        disabled/>
                              </div>
                              <small className="col-12 col-lg-3 text-muted">
                                  (Last KM Tempuh: {Number(gantiOdoForm.lastKmTempuh || 0).toLocaleString("id-ID")})
                                </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {selectedAction.value !== "storing" && selectedAction.value !== "ubah_seri" && selectedAction.value !== "ganti_odo" && (
                  <div className="card page16-info-card mt-3">
                    <div className="card-body">
                      <div className="page16-info-title mb-2">Template Panel</div>
                      <p className="text-muted small mb-2">
                        Konten detail untuk menu <strong>{selectedAction.title}</strong> masih berupa template.
                      </p>
                      <label className="form-label">Catatan Sementara</label>
                      <textarea
                        rows={3}
                        className="form-control"
                        placeholder="Isi catatan sementara (template)..."
                        value={formTemplate.catatan}
                        onChange={(e) => setFormTemplate((prev) => ({ ...prev, catatan: e.target.value }))}
                      />
                    </div>
                  </div>
                )}

                {selectedAction.value === "storing" && (
                  <div className="row g-3 mt-1">
                    {canShowStoringTambalFields && !!formTemplate.mt && (
                      <div className="col-12">
                        <div className="card page16-info-card">
                          <div className="card-body">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                              <span className="page16-info-title">Last Check</span>
                              <span className="badge text-bg-light">{selectedMt?.nopol || "-"}</span>
                            </div>
                            <div className="row g-2">
                              <div className="col-12 col-md-6">
                                <div className="page16-info-item">
                                  <small>ODO / KM TEMPUH MT</small>
                                  <button
                                    type="button"
                                    className="btn page16-gradient-btn text-white fw-bold"
                                    onClick={() => setShowOdoUpdateModalStoring(true)}
                                  >
                                    {storingLastCheck.loading
                                      ? "Memuat..."
                                      : `ODO: ${Number(storingLastCheck?.odo?.value || 0).toLocaleString("id-ID")}`}
                                  </button>
                                  <span className={storingLastCheck?.today?.odo ? "text-success" : "text-danger"}>
                                    {`Check: ${formatDate(storingLastCheck?.today?.odo ? todayKey : storingLastCheck?.odo?.date)} (${dayDiffLabel(storingLastCheck?.today?.odo ? todayKey : storingLastCheck?.odo?.date)})`}
                                  </span>
                                </div>
                              </div>
                              <div className="col-12 col-md-6">
                                <div className="page16-info-item">
                                  <small>TD BAN</small>
                                  <button
                                    type="button"
                                    className="btn page16-gradient-btn text-white fw-bold"
                                    onClick={() => setShowTdUpdateModalStoring(true)}
                                  >
                                    {storingLastCheck.loading
                                      ? "Memuat..."
                                      : `TD: ${Number(storingLastCheck?.td?.terpasang || 0)} + ${Number(storingLastCheck?.td?.cadangan || 0)} ban`}
                                  </button>
                                  <span className={storingLastCheck?.today?.td ? "text-success" : "text-danger"}>
                                    {`Check: ${formatDate(storingLastCheck?.today?.td ? todayKey : storingLastCheck?.td?.oldestDate)} (${dayDiffLabel(storingLastCheck?.today?.td ? todayKey : storingLastCheck?.td?.oldestDate)})`}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {(!storingLastCheck?.today?.odo || !storingLastCheck?.today?.td) && (
                              <div className="mt-2">
                                <small className="text-danger fst-italic fw-light">
                                  Submit hanya bisa dilanjutkan jika Last Check ODO dan TD sudah update per hari ini.
                                </small>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {canShowStoringTambalFields && (
                    <div className="col-12 col-lg-6">
                      <div className="card page16-soft-card h-100">
                        <div className="card-body d-flex justify-content-between align-items-center flex-wrap gap-2">
                          <div>
                            <div className="page16-info-title">Lihat Detail MT</div>
                          </div>
                          <button
                            type="button"
                            className="btn btn-outline-primary"
                            disabled={!formTemplate.mt}
                            onClick={openDetailMt}
                          >
                            Lihat
                          </button>
                        </div>
                      </div>
                    </div>
                    )}
                    {canShowStoringTambalFields && (
                      <div className="col-12 col-lg-6">
                        <div className="card page16-soft-card h-100">
                          <div className="card-body d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <div>
                              <div className="page16-info-title">Pilih Ban</div>
                            </div>
                            <button
                              type="button"
                              className={`btn btn-outline-primary ${canShowStoringTambalFields && selectedTambalBanRows.length === 0 ? "field-required-invalid-btn" : ""}`}
                              disabled={!formTemplate.mt || storingBanData.loading}
                              onClick={() => {
                                setShowPickBanModal(true);
                                if (!activeModalPosisi && selectedPosisi.length) setActiveModalPosisi(selectedPosisi[0]);
                              }}
                            >
                              {storingBanData.loading ? "Memuat..." : "Pilih"}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    {canShowStoringTambalFields && (
                      <div className="col-12">
                        <div className="card page16-soft-card">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <div className="fw-semibold">Daftar Ban Repair/Tambal</div>
                              {!selectedTambalBanRows.length && <small className="text-muted">Belum ada ban dipilih.</small>}
                            </div>
                            <div className="table-responsive">
                              <table className="table table-sm table-hover align-middle">
                                <thead>
                                  <tr>
                                    <th>ID Ban</th>
                                    <th>Seri Ban</th>
                                    <th>Posisi</th>
                                    <th>Status</th>
                                    <th style={{ minWidth: "200px" }}>Catatan</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {!selectedTambalBanRows.length && (
                                    <tr>
                                      <td colSpan={5} className="text-center text-muted">Belum ada ban dipilih.</td>
                                    </tr>
                                  )}
                                  {selectedTambalBanRows.map((row) => (
                                    <tr key={`storing-tambal-row-${row.id_ban}-${row.posisi}`}>
                                      <td>{Number(row.id_ban || 0)}</td>
                                      <td>{String(row.seri_ban || "-")}</td>
                                      <td>{String(row.posisi || "-")}</td>
                                      <td>
                                        <select
                                          className={`form-select form-select-sm ${!String(row.status_after || "").trim() ? "field-required-invalid" : ""}`}
                                          value={String(row.status_after || "")}
                                          onChange={(e) => updateBanAction(row.posisi, "status_after", e.target.value)}
                                        >
                                          {getTambalStatusOptions(row.status_before).map((opt) => (
                                            <option key={`storing-status-${row.id_ban}-${opt}`} value={opt}>
                                              {opt === "CASING" ? "Casing" : opt}
                                            </option>
                                          ))}
                                        </select>
                                      </td>
                                      <td>
                                        <button
                                          type="button"
                                          className={`form-control form-control-sm text-start ${isBanActionDetailInvalid(row) ? "field-required-invalid" : ""}`}
                                          onClick={() => {
                                            setActiveTambalDetailPosisi(String(row.posisi || "").trim());
                                            setShowTambalDetailModal(true);
                                          }}
                                        >
                                          {String(row?.catatan || "").trim() || String(row?.jenis_tambal || "").trim() || String(row?.bahan_tambal || "").trim() || "-"}
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {canShowStoringTambalFields && (
                    <div className="col-12">
                      <div className="card page16-soft-card h-100">
                        <div className="card-body">
                          <div className="d-flex justify-content-center">
                            <span>{labelUpload}</span>
                          </div>
                          <PageKonten9_Pict
                            attachments={attachments}
                            setAttachments={setAttachments}
                            bisaInput={true}
                            invalidCaptionIndexes={invalidCaptionIndexesStoring}
                            onCaptionChange={() => setInvalidCaptionIndexesStoring([])}
                          />
                        </div>
                      </div>
                    </div>
                    )}

                    

        

                  </div>
                )}

                {selectedAction.value === "storing" && canShowStoringTambalFields && (
                  <div className="card page16-verify-card page16-soft-card mt-4">
                    <div className="card-body">
                      <div className="row g-2 justify-content-between align-items-center">
                        <div className="col-12 col-md-7">
                          <label className="form-label mb-0">Petugas Input</label>
                        </div>
                        <div className="col-12 col-md-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Nama petugas input"
                            value={namaPemeriksaStoring}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {selectedAction.value === "ubah_seri" && (
                  <div className="card page16-soft-card mt-3">
                    <div className="card-body">
                      <div className="d-flex justify-content-center">
                        <span>Upload Dokumen Pendukung</span>
                      </div>
                      <PageKonten9_Pict
                        attachments={attachmentsUbahId}
                        setAttachments={setAttachmentsUbahId}
                        bisaInput={true}
                        uploadInputClassName={invalidUbahIdLampiran ? "bg-warning-subtle border-warning" : ""}
                        invalidCaptionIndexes={mergedInvalidCaptionIndexesUbahId}
                        onCaptionChange={() => {
                          if (!invalidCaptionIndexesUbahId.length) return;
                          setInvalidCaptionIndexesUbahId([]);
                        }}
                      />
                    </div>
                  </div>
                )}

                {selectedAction.value === "ganti_odo" && (
                  <div className="card page16-soft-card mt-3">
                    <div className="card-body">
                      <div className="d-flex justify-content-center">
                        <span>Upload Dokumen Pendukung</span>
                      </div>
                      <PageKonten9_Pict
                        attachments={attachmentsGantiOdo}
                        setAttachments={setAttachmentsGantiOdo}
                        bisaInput={isGantiOdoReadyForVerify}
                        uploadInputClassName={invalidGantiOdoLampiran ? "bg-warning-subtle border-warning" : ""}
                        invalidCaptionIndexes={mergedInvalidCaptionIndexesGantiOdo}
                        onCaptionChange={() => {
                          if (!invalidCaptionIndexesGantiOdo.length) return;
                          setInvalidCaptionIndexesGantiOdo([]);
                        }}
                      />
                      {!isGantiOdoReadyForVerify && (
                        <small className="text-muted d-block mt-2">
                          Lengkapi data wajib Ganti ODO terlebih dahulu untuk mengaktifkan input dokumen.
                        </small>
                      )}
                    </div>
                  </div>
                )}

                {selectedAction.value === "ubah_seri" && isUbahIdReadyForVerify && (
                  <div className="card page16-verify-card page16-soft-card mt-4">
                    <div className="card-body">
                      <div className="row g-2 justify-content-between align-items-center">
                        <div className="col-12 col-md-8">
                          <span className="fw-semibold">Petugas Input</span>
                        </div>
                        <div className="col-12 col-md-4 ms-md-auto">
                          <input
                            type="text"
                            className={`form-control ${invalidUbahIdUser ? "field-required-invalid" : ""}`}
                            value={ubahIdForm.namaUser}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {selectedAction.value === "ganti_odo" && isGantiOdoReadyForVerify && (
                  <div className="card page16-verify-card page16-soft-card mt-4">
                    <div className="card-body">
                      <div className="row g-2 justify-content-between align-items-center">
                        <div className="col-12 col-md-8">
                          <span className="fw-semibold">Petugas Input</span>
                        </div>
                        <div className="col-12 col-md-4 ms-md-auto">
                          <input
                            type="text"
                            className={`form-control ${invalidGantiOdoUser ? "field-required-invalid" : ""}`}
                            value={gantiOdoForm.namaUser}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="d-flex justify-content-end gap-2 mt-3">
                  <button type="button" className="btn btn-outline-secondary" onClick={() => setActiveAction("")}>
                    Batal
                  </button>
                  {selectedAction.value === "storing" ? (
                    isStoringBaseReady && (
                      <button
                        type="button"
                        className="btn page16-gradient-btn text-white"
                        onClick={handleOpenStoringRotasiModal}
                      >
                        Lanjutkan
                      </button>
                    )
                  ) : (
                    <button
                      type="button"
                      className="btn page16-gradient-btn text-white"
                      onClick={() => handleSubmitTemplate()}
                      disabled={
                        (selectedAction.value === "ganti_odo" && (!isGantiOdoValid || !isGantiOdoAttachmentValid || isSubmittingGantiOdo))
                        || (selectedAction.value === "ubah_seri" && (!isUbahIdValid || !isUbahIdAttachmentValid || isSubmittingUbahId))
                      }
                    >
                      {selectedAction.value === "ganti_odo" && isSubmittingGantiOdo
                          ? "Memproses..."
                        : selectedAction.value === "ubah_seri" && isSubmittingUbahId
                          ? "Memproses..."
                          : selectedAction.submitLabel}
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {showPickBanModal && (
        <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card page26-storing-modal">
            <div className="d-flex justify-content-between align-items-start mb-3 pb-2 border-bottom">
              <div>
                <h5 className="mb-1">Pilih Ban Tambal - {selectedMt?.nopol || "-"}</h5>
                <small className="text-muted">
                  Klik ban di formasi untuk menambah/mengurangi daftar ban yang akan ditambal.
                </small>
              </div>
              <button type="button" className="btn btn-sm btn-primary" onClick={() => setShowPickBanModal(false)}>
                Selesai
              </button>
            </div>

            <div className="row page26-storing-grid g-3 align-items-start">
              <div className="col-12 col-xl-7">
                <div className="page16-popup-formasi page26-storing-formasi">
                  <FormasiBan
                    formasi={Number(selectedMtProfil?.roda || selectedMt?.roda || 16)}
                    cadangan={Number(selectedMtProfil?.cadangan || selectedMt?.cadangan || 3)}
                    onClick={togglePosisiBan}
                    daftarKodeBan={storingBanData.daftarKodeBan}
                    highlightedPosisi={selectedPosisi}
                  />
                </div>
              </div>
              <div className="col-12 col-xl-5">
                <div className="page16-popup-detail w-100 page26-storing-selection-box">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <strong>Ban Terpilih ({selectedPosisi.length})</strong>
                    {!selectedPosisi.length && <small className="text-muted">Belum ada</small>}
                  </div>
                  <div className="d-flex flex-wrap gap-2 mb-2">
                    {selectedPosisi.map((pos) => {
                      const active = activeModalPosisi === pos;
                      return (
                        <button
                          key={`storing-pos-chip-${pos}`}
                          type="button"
                          className={`btn btn-sm ${active ? "btn-primary" : "btn-outline-primary"}`}
                          onClick={() => setActiveModalPosisi(pos)}
                        >
                          {pos}
                        </button>
                      );
                    })}
                  </div>

                  {!!activeModalBan && (
                    <div className="page26-storing-detail-panel">
                      <h6 className="mb-2">{activeModalBan.posisi} | {activeModalBan.seri}</h6>
                      <div className="row g-1 small mb-2">
                        <div className="col-6"><strong>ID Ban</strong></div><div className="col-6 text-end">{activeModalBan.idBan || "-"}</div>
                        <div className="col-6"><strong>Merk</strong></div><div className="col-6 text-end">{activeModalBan.merk || "-"}</div>
                        <div className="col-6"><strong>KMT</strong></div><div className="col-6 text-end">{Number(activeModalBan.kmt || 0).toLocaleString("id-ID")}</div>
                        <div className="col-6"><strong>TD</strong></div><div className="col-6 text-end">{activeModalBan.td || "-"}</div>
                      </div>

                      <strong className="small d-block mb-1">Histori Ban</strong>
                      <div className="page16-rotasi-histori">
                        {(activeModalBan.histori || []).slice(0, 10).map((item, idx) => (
                          <div key={`storing-modal-hist-${idx}`} className="page16-rotasi-histori-item">
                            <small className="text-muted">
                              {String(item?.tanggal || "").trim().slice(0, 10) || "-"} | {item?.event || "-"}
                            </small>
                          </div>
                        ))}
                        {!activeModalBan.histori?.length && <small className="text-muted">Belum ada histori.</small>}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showDetailMtPage && selectedMtDetail && (
        <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
        <div className="page16-modal-card" style={{ width: '90vw', maxHeight: '92vh', overflowY: 'auto' }}>

            <PageKonten9_Show
              globalOpsi={globalOpsi}
              editData={selectedMtDetail}
              setShowDetail={setShowDetailMtPage}
              setShowMaster={() => {}}
            />
          </div>
        </div>
      )}

      <ModalCariBan
        open={showCariBanIdUnikModal}
        onClose={() => setShowCariBanIdUnikModal(false)}
        showNotif={showNotif}
        onSelect={(ban) => {
          const seriBan = String(ban?.seri_ban || "").trim();
          setUbahIdForm((prev) => ({
            ...prev,
            selectedBan: { id_ban: Number(ban?.id_ban || 0), seri_ban: seriBan },
            seriSementara: prev.seriSementara || seriBan,
          }));
        }}
        globalOpsi={globalOpsi}
        kodeCabang={ubahIdForm.kodeCabang || (!isPusat ? actorKodeCabang : "")}
        enableKodeSementara={true}
        defaultKodeSementara={true}
      />

      <ModalCariMT
        open={showCariMtIdUnikModal}
        onClose={() => setShowCariMtIdUnikModal(false)}
        showNotif={showNotif}
        onSelect={(mt) => {
          setUbahIdForm((prev) => ({
            ...prev,
            selectedMt: { id_mt: mt.id_mt, nopol: mt.nopol },
            nopolLama: prev.nopolLama || String(mt.nopol || ""),
          }));
        }}
        globalOpsi={globalOpsi}
        kodeCabang={ubahIdForm.kodeCabang || (!isPusat ? actorKodeCabang : "")}
      />

      <ModalCariMT
        open={showCariMtGantiOdoModal}
        onClose={() => setShowCariMtGantiOdoModal(false)}
        showNotif={showNotif}
        onSelect={(mt) => {
          const idMt = String(mt?.id_mt || "").trim();
          const nopol = String(mt?.nopol || "").trim();
          setGantiOdoForm((prev) => ({
            ...prev,
            selectedMt: { id_mt: idMt, nopol },
          }));
        }}
        title="Pilih No. Pol MT"
        globalOpsi={globalOpsi}
        kodeCabang={gantiOdoForm.kodeCabang || (!isPusat ? actorKodeCabang : "")}
      />

      <ModalCariMT
        open={showCariMtStoringModal}
        onClose={() => setShowCariMtStoringModal(false)}
        showNotif={showNotif}
        onSelect={(mt) => {
          const idMt = String(mt?.id_mt || "").trim();
          setFormTemplate((prev) => ({ ...prev, mt: idMt }));
          const roda = Number(mt?.roda || 0);
          const cadangan = Number(mt?.cadangan || 0);
          if (idMt && (roda > 0 || cadangan >= 0)) {
            setMtProfilMap((prev) => ({
              ...(prev || {}),
              [idMt]: {
                roda: roda > 0 ? roda : Number(prev?.[idMt]?.roda || 0),
                cadangan: cadangan >= 0 ? cadangan : Number(prev?.[idMt]?.cadangan || 0),
              },
            }));
          }
        }}
        title="Pilih No. Pol MT"
        enrichFields={["roda", "cadangan"]}
        globalOpsi={globalOpsi}
        kodeCabang={formTemplate.kodeCabang || (!isPusat ? actorKodeCabang : "")}
      />

      <ModalTambalDetail
        open={showTambalDetailModal}
        row={activeTambalDetailRow}
        opsiJenisTambal={opsiJenisTambal}
        opsiBahanTambal={opsiBahanTambal}
        onClose={() => {
          setShowTambalDetailModal(false);
          setActiveTambalDetailPosisi("");
        }}
        onSave={(detail) => {
          const posisi = String(activeTambalDetailPosisi || "").trim();
          if (!posisi) return;
          setBanActionMap((prev) => ({
            ...(prev || {}),
            [posisi]: {
              ...(prev?.[posisi] || {}),
              jenis_tambal: String(detail?.jenis_tambal || "").trim(),
              bahan_tambal: String(detail?.bahan_tambal || "").trim(),
              qty_tambal: Number(detail?.qty_tambal || 0),
              catatan: String(detail?.catatan || ""),
            },
          }));
          setShowTambalDetailModal(false);
          setActiveTambalDetailPosisi("");
        }}
      />

      {showTdUpdateModalGantiOdo && (
        <div className="page16-modal-backdrop page25-td-update-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card" style={{ width: "97vw" }}>
            <PageKonten15OdoTd
              authIdentity={authIdentity}
              globalOpsi={globalOpsi}
              resendToken={resendToken}
              mode="modal"
              forcedAction="td"
              presetMtId={gantiOdoForm.selectedMt?.id_mt || ""}
              presetKodeCabang={gantiOdoForm.kodeCabang || (!isPusat ? actorKodeCabang : "")}
              presetTanggal={todayKey}
              onClose={() => setShowTdUpdateModalGantiOdo(false)}
              onAfterSave={handleGantiOdoTdSaved}
            />
          </div>
        </div>
      )}
      {showGantiOdoZeroConfirmModal && (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.45)" }} role="dialog" aria-modal="true" aria-labelledby="ganti-odo-zero-confirm-title">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 id="ganti-odo-zero-confirm-title" className="modal-title">Konfirmasi ODO</h5>
                <button type="button" className="btn-close" aria-label="Tutup" onClick={() => setShowGantiOdoZeroConfirmModal(false)} />
              </div>
              <div className="modal-body">
                ODO PASANG dan ODO SAAT ini seharusnya diisi dengan nilai ODO terpasang yang tertera pada dashboard MT. Anda yakin menginput nilai odo yang terpasang saat ini = 0 ?
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-outline-secondary" onClick={() => setShowGantiOdoZeroConfirmModal(false)}>
                  Batal
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    setShowGantiOdoZeroConfirmModal(false);
                    handleSubmitTemplate(true);
                  }}
                >
                  Ya, sudah benar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showRefreshOdoZeroConfirmModal && (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.45)" }} role="dialog" aria-modal="true" aria-labelledby="refresh-odo-zero-confirm-title">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 id="refresh-odo-zero-confirm-title" className="modal-title">Konfirmasi ODO</h5>
                <button type="button" className="btn-close" aria-label="Tutup" onClick={() => setShowRefreshOdoZeroConfirmModal(false)} />
              </div>
              <div className="modal-body">
                ODO SAAT ini seharusnya diisi dengan nilai ODO yang tertera pada dashboard MT. Anda yakin menginput nilai odo yang terpasang saat ini = 0 ?
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-outline-secondary" onClick={() => setShowRefreshOdoZeroConfirmModal(false)}>
                  Batal
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    setShowRefreshOdoZeroConfirmModal(false);
                    handleSubmitTemplate(true);
                  }}
                >
                  Ya, sudah benar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showRotasiBanModal && (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.45)" }}>
          <div className="modal-dialog modal-dialog-scrollable" style={{ width: "100vw", maxWidth: "100vw", height: "100vh", maxHeight: "100vh", margin: 0 }}>
            <div className="modal-content" style={{ height: "100vh", maxHeight: "100vh", borderRadius: 0 }}>
              <div className="modal-header">
                <h5 className="modal-title mb-0">Storing Rotasi/Ganti dan Repair Ban</h5>
                <button type="button" className="btn-close" onClick={() => setShowRotasiBanModal(false)} />
              </div>
              <div className="modal-body" style={{ overflowY: "auto" }}>
                <PageKonten32_Rotasi
                  globalOpsi={globalOpsi}
                  editData={rotasiModalData}
                  authIdentity={authIdentity}
                  setShowDetail={setShowRotasiBanModal}
                  setShowMaster={() => {}}
                  reloadToken={resendToken}
                  onSubmitSuccess={() => {
                    setShowRotasiBanModal(false);
                    handlePilihAction("storing");
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {showOdoUpdateModalStoring && (
        <div className="page16-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card" style={{ width: "min(1180px, 97vw)" }}>
            <PageKonten15OdoTd
              authIdentity={authIdentity}
              globalOpsi={globalOpsi}
              resendToken={resendToken}
              mode="modal"
              forcedAction="odo"
              presetMtId={formTemplate.mt || ""}
              presetKodeCabang={formTemplate.kodeCabang || (!isPusat ? actorKodeCabang : "")}
              presetTanggal={todayKey}
              onClose={() => setShowOdoUpdateModalStoring(false)}
              onAfterSave={handleStoringLastCheckSaved}
            />
          </div>
        </div>
      )}
      {showTdUpdateModalStoring && (
        <div className="page16-modal-backdrop page25-td-update-modal-backdrop" role="dialog" aria-modal="true">
          <div className="page16-modal-card" style={{ width: "97vw" }}>
            <PageKonten15OdoTd
              authIdentity={authIdentity}
              globalOpsi={globalOpsi}
              resendToken={resendToken}
              mode="modal"
              forcedAction="td"
              presetMtId={formTemplate.mt || ""}
              presetKodeCabang={formTemplate.kodeCabang || (!isPusat ? actorKodeCabang : "")}
              presetTanggal={todayKey}
              onClose={() => setShowTdUpdateModalStoring(false)}
              onAfterSave={handleStoringLastCheckSaved}
            />
          </div>
        </div>
      )}

    </div>
  );
}
